(function() {
  'use strict';

  angular
    .module('app', ['ngMessages', 'ngResource', 'ui.router', 'toastr', 'angularPayments', '720kb.socialshare', 'ngQuill']);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appTextarea', directive);

  /** @ngInject */
  function directive() {

    return {
      template: '<section class="app-textarea">' +
        '    	<div class="row">' +
        '      		<div class="small-12 columns">' +
        '        		<div class="label-wrapper">' +
        '          		<label for="{{id}}">{{label}} <span class="hint">{{hint}}</span></label>' +
        '       		</div>' +
        '        	<div class="input-wrapper">' +
         '           	<textarea id="{{id}}" placeholder="{{placeholder}}"  rows="{{rows || 10}}" cols="{{cols}}"  ng-model="ngModel" ng-readonly="{{readonly}}"/> ' +
        '             	<div ng-transclude></div> ' + 
        '        	</div>' +
        '      	</div>' +
        '    </div>' +
        '  </section>',
      //templateUrl: 'app/components/Textarea/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              klass: '=',
              id: "=",
	          label: "=",
	          ngModel: "=",
	          rows: "=",
	          cols: "=",
	          placeholder: "=",
	          hint: "=",
            readonly: "="
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appSubmit', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Submit/template.html',
        restrict: 'E',
        replace: true,
        scope: {
              klass: '=',
              txt: '='
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appSection', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Section/template.html',
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
            zid: "=",
            intro: "=",
            ttl: "=",
            subtitle: "=",
            lighttext: "=",
            desc: "=",
            cta: "=",
            ctaoptions: "=",
            image: "=",
            unsplash: "=",
            featured: "=",
            klass: "="
        }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appRow', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Row/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              klass: '='
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appRichtextarea', directive);

  /** @ngInject */
  function directive() {

    return {
      template: '<section class="app-richtextarea {{klass}}">' +
                    '<div class="row">' +
                      '<div class="small-12 columns">' +
                        '<div class="label-wrapper">' +
                        '<label for="{{id}}"><span class="label-text">{{label}}</span> <span class="hint">{{hint}}</span></label>' +
                        '</div>' +
                        '<div class="input-wrapper">' +
                         '<ng-quill-editor ng-model="ngModel" toolbar="{{toolbar}}" link-tooltip="linkTooltip" image-tooltip="imageTooltip" toolbar-entries="{{toolbarEntries}}" ' +
                         'editor-required="editorRequired" required="{{inputRequired}}" error-class="{{inputError}}"></ng-quill-editor>' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                  '</section>',
      // templateUrl: 'app/components/RichTextEditor/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
            klass: '=',
            id: "=",
            label: "=",
            ngModel: "=",
            readonly: "=",
            inputRequired: "=",
            toolbar: "=",
            linkTooltip: "=",
            imageTooltip: "=",
            required: "=",
            toolbarEntries: "=",
            editorRequired: "=",
            inputError: "="
          }
     };
    }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appPhoto', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Photo/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              klass: '=',
              ttl: '=',
              image: '=',
              subtitle: '=',
              description: '='
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appPage', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Page/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              klass: '=',
              ttl: '=',
              subtitle: '='
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appNavbar2', directive);

  /** @ngInject */
  function directive() {
    return{
      restrict: 'E',
      templateUrl: 'app/components/NavBar2/template.html',
      scope: {
          accent: '='
      },
      //controller: NavbarController,
      //controllerAs: 'vm',
      //bindToController: true
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appNavbar', directive);

  /** @ngInject */
  function directive() {
    return{
      restrict: 'E',
      templateUrl: 'app/components/NavBar/template.html',
      // scope: {
      //     creationDate: '='
      // },
      //controller: NavbarController,
      //controllerAs: 'vm',
      //bindToController: true
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appMedia', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Media/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              ttl: "=",
              intro: "=",
              subtitle: "=",
              imaged: "=",
              imaget: "=",
              imagem: "=",
              desc: "=",
              cta: "=",
              ctalink: "=",
              klass: "="
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appInput', directive);

  /** @ngInject */
  function directive() {

    return {
      template: '<section class="app-input">' +
                '    <div class="row">' +
                '      <div class="small-12 columns">' +
                '        <div class="label-wrapper">' +
                  '          <label for="{{id}}">{{label}} <span class="hint">{{hint}}</span></label>' +
                 '       </div>' +
                '        <div class="input-wrapper">' +
                 '           <input id="{{id}}" type="{{type}}" name="{{name}}" placeholder="{{placeholder}}" ng-model="ngModel"/> ' +
                '             <div ng-transclude></div> ' + 
                '        </div>' +
                '      </div>' +
                '    </div>' +
                '  </section>',
        //templateUrl: "/app/components/InputBox/template.html",
        restrict: 'E',
        require: '?ngModel',
        transclude: true,
        replace: true,
        link: postLink,
      scope: {
          id: "=",
          label: "=",
          ngModel: "=",
          type: "=",
          placeholder: "=",
          hint: "=",
          readonly: "=",
          name: "="
      }
    };

    /** @ngInject */
    function postLink(scope, element, attrs, ngModel) {

            var input =  element.find('input');

          if (attrs.required) {
            input.attr('required', "required");
          }

          if (attrs.step) {
            input.attr('step', attrs.step);
          }
         
      }

  }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .directive('appLogo', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Logo/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              klass: '=',
              //title: '='
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appIconlink', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/IconLink/template.html',
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
              href: "=",
              text: "=",
              klass: "=",
          }
    };
  }

})();

'use strict';

function dfSvgIcon(iconName, svgFile){
  angular.module('app')
  .directive(iconName, ["$rootScope", function ($rootScope) {
      return {
          templateUrl: "./assets/svg/" + svgFile + ".svg",
          restrict: 'AE',
          replace: true,
      };
  }]);
}

dfSvgIcon('iconLogo', "logo");

/* ADD */
dfSvgIcon('iconAdd1', "add-1");
dfSvgIcon('iconAdd2', "add-2");

/* CLOCKS */
dfSvgIcon('iconAlarmclock', "alarm-clock");

/* DELETE */
dfSvgIcon('iconDelete', "bin-1");

/* HELP */
dfSvgIcon('iconHelp', "business-question");
dfSvgIcon('iconHelpcircle', "help-circle");

/* DATES */
dfSvgIcon('iconCalendar', "calendar-2");

/* CURRENCY */
dfSvgIcon('iconDollar', "dollar-sign");

/* FILES */
dfSvgIcon('iconChecklistedit', "file-checklist-edit");
dfSvgIcon('iconChecklist', "file-checklist");

/* JOBS */
dfSvgIcon('iconFindjobs', "find-job");

/* GROUPS */
dfSvgIcon('iconGroup1', "group-1");
dfSvgIcon('iconGroup2', "group-2");
dfSvgIcon('iconGroupadd2', "group-add-2");
dfSvgIcon('iconGroupcheck', "group-check");
dfSvgIcon('iconGroupedit', "group-edit");
dfSvgIcon('iconGroupfavoriteheart', "group-favorite-heart");
dfSvgIcon('iconGroupfavoritestar', "group-favorite-star");
dfSvgIcon('iconGrouplock', "group-lock");
dfSvgIcon('iconGroupremove', "group-remove");
dfSvgIcon('iconGroupsubtract2', "group-subtract-2");

dfSvgIcon('iconBusiness1', "building-3");

/* HOMES and HOUSES */
dfSvgIcon('iconHome1', "home-1");
dfSvgIcon('iconHome3', "home-3");
dfSvgIcon('iconHome5', "home-5");

dfSvgIcon('iconHouselocationpin', "house-location-pin");
dfSvgIcon('iconHouseprice', "house-price");
dfSvgIcon('iconHouseremove', "house-remove");
dfSvgIcon('iconHouserent', "house-rent");

/* MESSAGES */
dfSvgIcon('iconUserchat1', "user-chat-1");

/* TASKS */
dfSvgIcon('iconTaskadd', "task-add");


/* GADGETS */
dfSvgIcon('iconIphone', "iphone");
dfSvgIcon('iconIpad', "ipad"); 

/* LOCATION */
dfSvgIcon('iconLocationpin2', "location-pin-2"); 
dfSvgIcon('iconLocationpinhome2', "location-pin-home-2"); 
dfSvgIcon('iconLocationpinuser2', "location-pin-user-2");

/* LOCKS */
dfSvgIcon('iconLockclose1', "lock-close-1");
dfSvgIcon('iconLock', "lock-open-1");

/* NAVIGATION */
dfSvgIcon('iconNavigationdrawer2', "navigation-drawer-1");
dfSvgIcon('iconNavigationShowmore1', "navigation-show-more-1");
dfSvgIcon('iconNavigationShowmore2', "navigation-show-more-2");

/* NOTES */
dfSvgIcon('iconNotepad2', "notepad-2");

/* PEOPLE AND USERS */
dfSvgIcon('iconPerson1', "person-1");
dfSvgIcon('iconPerson2', "person-2");
dfSvgIcon('iconPersonadd1', "person-add-1");
dfSvgIcon('iconPersonadd2', "person-add-2");
dfSvgIcon('iconPersonedit1', "person-edit-1");
dfSvgIcon('iconPersonedit2', "person-edit-2");
dfSvgIcon('iconPersonfavoriteheart2', "person-favorite-heart-2");
dfSvgIcon('iconPersonfavoritestar2', "person-favorite-star-2");
dfSvgIcon('iconPersonRemove2', "person-remove-2");  //dfSvgIcon('icon', "");


dfSvgIcon('iconUsersinhome', "users-in-home");

/* PROFILE */
dfSvgIcon('iconProfile', "profile");

/* SHARE */
dfSvgIcon('iconShare', "share");
dfSvgIcon('iconEmail', "share-email");
dfSvgIcon('iconFacebook', "share-facebook");
dfSvgIcon('iconTwitter', "share-twitter-bird");

/* SIGNS */
dfSvgIcon('iconSignforrent1', "sign-for-rent-1");
dfSvgIcon('iconSignforrent2', "sign-for-rent-2");



/* REWARDS */
dfSvgIcon('iconMedal1', "medal-1");
dfSvgIcon('iconMedal3', "medal-3");



angular.module('app')
  .directive('chartIcon', ["$rootScope", function ($rootScope) {
      return {
          //template: '<div></div>',
          templateUrl: "/scripts/__icon_directives/charticon.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
      };
  }]).directive('badgeIcon', ["$rootScope", function ($rootScope) {

      //DDO - Directive Definition Object
      return {
          templateUrl: "/scripts/__icon_directives/badge.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
          scope: {}
      };
  }]).directive('personEditIcon', ["$rootScope", function ($rootScope) {
      return {
          templateUrl: "/scripts/__icon_directives/person-edit.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
          scope: {}
      };
  }]).directive('documentIcon', ["$rootScope", function ($rootScope) {
      return {
          templateUrl: "/scripts/__icon_directives/document.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
          scope: {}
      };
  }]).directive('usersIcon', ["$rootScope", function ($rootScope) {
      return {
          templateUrl: "/scripts/__icon_directives/users.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
          scope: {}
      };
  }]).directive('searchIcon', ["$rootScope", function ($rootScope) {
      return {
          templateUrl: "/scripts/__icon_directives/search.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
          scope: {}
      };
  }]).directive('lockIcon', ["$rootScope", function ($rootScope) {
      return {
          templateUrl: "/scripts/__icon_directives/lock.html",
          restrict: 'AE',
          replace: true,
          link: function postLink(scope, element, attrs) {},
          scope: {}
      };
  }])
  ;

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appHero', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Hero/template.html',
        restrict: 'E',
        replace: true,
        transclude: true, 
        scope: {
              zid: "=",
              ttl: "=",
              intro: "=",
              subtitle: "=",
              image: "=",
              unsplash: "=",
              desc: "=",
              boom: "&",
              cta: "=",
              ctalink: "=",
              ctaclass: "=",
              klass: "=",
              animated: "=",
              maskoptions: "="
          }
     };

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appField', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/Field/template.html',
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
              label: "=",
              value: "="
          }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appDropdown', directive);

  /** @ngInject */
  function directive() {

    return {
      template: '<section class="app-dropdown">' +
                '    <div class="row">' +
                '      <div class="small-12 columns">' +
                '        <div class="label-wrapper">' +
                  '          <label for="{{id}}">{{label}} <span class="hint">{{hint}}</span></label>' +
                 '       </div>' +
                '        <div class="input-wrapper">' +
                '           <select id="{{id}}" type="{{type}}" name="{{name}}" placeholder="{{placeholder}}" ng-model="ngModel"> ' + 
                '            <option ng-repeat="item in list" ng-value="item.value">{{item.name || item.title || item.text}}</option>'  +          
                '           </select> ' +
                //'             <div ng-transclude></div> ' + 
                '        </div>' +
                '      </div>' +
                '    </div>' +
                '  </section>',
        //templateUrl: "/app/components/InputBox/template.html",
        restrict: 'E',
        require: '?ngModel',
        transclude: true,
        replace: true,
        link: postLink,
      scope: {
          id: "=",
          label: "=",
          ngModel: "=",
          type: "=",
          placeholder: "=",
          hint: "=",
          list: "=",
          name: "="
      }
    };

    /** @ngInject */
    function postLink(scope, element, attrs, ngModel) {

            var input =  element.find('input');

          if (attrs.required) {
            input.attr('required', "required");
          }

          // if (attrs.step) {
          //   input.attr('step', attrs.step);
          // }
         
      }

  }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .directive('appContentblock', directive);

  /** @ngInject */
  function directive() {

    return {
      templateUrl: 'app/components/ContentBlock/template.html',
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
              ttl: "=",
              subtitle: "=",
              image: "=",
              text: "=",
              cta: "=",
              ctalink: "=",
              ctaklass: "=",
              klass: "="
          }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('appCheckbox', directive);

  /** @ngInject */
  function directive() {

    return {
      template: '<section class="app-checkbox">' +
                '    <div class="row">' +
                '      <div class="small-12 columns">' +
                '        <div class="label-wrapper">' +
           //     '          <label for="{{id}}">{{label}} <span class="hint">{{hint}}</span></label>' +
           '       <div class="text-label">{{label}}</div>' + 
                '       </div>' +
                '        <div class="input-wrapper">' +
                '           <label for="{{id}}"><input id="{{id}}" type="checkbox" name="{{name}}" placeholder="{{placeholder}}" ng-model="ngModel"/> <span class="check-text " ng-class="{bold: bold}">{{text || label}}</span> </label>' +
                '             <div ng-transclude></div> ' + 
                '        </div>' +
                '      </div>' +
                '    </div>' +
                '  </section>',
        //templateUrl: "/app/components/InputBox/template.html",
        restrict: 'E',
        require: '?ngModel',
        transclude: true,
        replace: true,
        link: postLink,
        scope: {
          id: "=",
          label: "=",
          ngModel: "=",
          placeholder: "=",
          hint: "=",
          text: "=",
          name: "=",
          bold: "="
      }
    };

    /** @ngInject */
    function postLink(scope, element, attrs, ngModel) {

            var input =  element.find('input');

          if (attrs.required) {
            input.attr('required', "required");
          }

          if (attrs.step) {
            input.attr('step', attrs.step);
          }
         
      }

  }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .factory('Unsplash', factory);

  /** @ngInject */
  function factory(moment) {
       var url = 'https://source.unsplash.com/';
        var id;

       function get(size){
          return url + id + "/" + size.width + "x" + size.height;
        }


     return { 
      get: function(imageId){ 
        id = imageId;

        var images = {
          mobile: get({ width: '700', height: '600'}),
          tablet: get({ width: '1060', height: '500'}),
          desktop: get({ width: '1900', height: '700'}),
        };

        return images;
      },
      getAnimated: function(imageId){ 
        id = imageId;

        var images = {
          mobile: get({ width: '1500', height: '500'}),
          tablet: get({ width: '2000', height: '600'}),
          desktop: get({ width: '2500', height: '700'}),
        };

        return images;
      },
      one: function(imageId){
        id = imageId;
        return get({ width: '800', height: '400'});
      },
      random: function(){

      },
      tech: function(){

      },
      people: function(){

      },
      nature: function(){

      },
    }
  }
  
})();

(function() {
  'use strict';
  angular
    .module('app')
    .provider('StateHelper', provider);

  /** @ngInject */
  function provider() {

      this.states = {
            main: {
              name: "main",
              url: "/",
              templateUrl: 'app/main/main.html',
              controller: 'MainController',
              controllerAs: 'vm',
              resolve: {
                /** @ngInject */
                appData: function($q, Session){
                  var deferred = $q.defer();

                  Session.init(function(){
                    deferred.resolve(function(){
                      console.log('Hello!!! We have Data, ');
                      return true;
                    });
                  });

                  return deferred.promise;

                }
              }
            },
            admin: {
              name: "main",
              url: "/",
              templateUrl: 'app/main/main.html',
              controller: 'AdminController',
              controllerAs: 'vm'
            },
        
      };

      this.$get = function(){
        return new provider();
      };   
  }
    
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('Session', factory);

  /** @ngInject */
  function factory($rootScope, LocaleService) {
      var version = 0,
        currentLocale;

    function setupAnimations(){
      function getWowString(anim){
        return "animated " + anim + " wow _slow";
      }

      $rootScope.anim = getWowString("fadeInUp");
      
      $rootScope.fade = getWowString("fadeIn");
      $rootScope.fadeUp = getWowString("fadeInUp");
      $rootScope.fadeDown = getWowString("fadeInDown");
      $rootScope.zoom = getWowString("zoomIn");
      $rootScope.bounce = getWowString("bounce");
      $rootScope.bounceIn = getWowString("bounceIn");
      $rootScope.bounceUp = getWowString("bounceInUp");
      $rootScope.jello = getWowString("jello");

        //$rootScope.splash = "https://source.unsplash.com/tCICLJ5ktBE/1900x700"
    }

  
    function getUserLocale(){
      LocaleService.getCurrentLocale(function(data){
          currentLocale = data;
          $rootScope.currentLocale = currentLocale;
      });
    }



  return {
          init: function (callback) {
            //getUserLocale();
            setupAnimations();

            callback();
            
          },
          currentLocale: function(){
              return currentLocale;
          }
          
      };
    }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('PaymentService', factory);

  /** @ngInject */
  function factory() {


     return {
        processPayment: function(data, success, error){
          //TODO: process payment and then success/error
          success();
        }
     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('Notifier', factory);

  /** @ngInject */
  function factory($rootScope, toastr) {

    toastr.options = {
  // "closeButton": false,
  // "debug": false,
  // "newestOnTop": false,
  // "progressBar": false,
  "positionClass": "toast-top-center",
  // "preventDuplicates": false,
  // "onclick": null,
  // "showDuration": "300",
  // "hideDuration": "1000",
  // "timeOut": "100000",
   //"extendedTimeOut": "100000",
  // "showEasing": "swing",
  // "hideEasing": "linear",
  // "showMethod": "fadeIn",
  // "hideMethod": "fadeOut"
}

    return {
        success: function (options) {
          
            toastr.success(options.message, options.title || "");
        },
        warning: function (options) {
            toastr.warning(options.message, options.title || "");
        },
        error: function (options) {
          toastr.error(options.message);
      },
    };
}

})();
(function() {
  'use strict';

  angular
    .module('app')
    .factory('Nav', factory);

  /** @ngInject */
   function factory($location, $rootScope, $state, Models) {

   
      function go(state, params, reload) {
          if (params){
            //return  $location.path("/" + path + "/" + id);
              if(reload){
            return  $state.go(state, params, {reload: true});
              }
            return  $state.go(state, params);
          }else{
            $location.path("/" + state || "");

          }
      }

    return {
        navigate: function(path, options){
            $location.path("/" + path).search(options);
        },
        home: function () {
            go("main.home");
        },
        portal: function () {
             $state.go("main.listings", {}); 
        },
        signup: function () {
             $state.go("main.signup"); 
        },
        signupcompany: function (params) {
             $state.go("main.signupcompany", params); 
        },
        signupuser: function (params) {
             $state.go("main.signupuser", params); 
        },
        listings: function (params){
              $state.go("main.listings", params);
        },
        postalisting: function (params){
              $state.go("main.postalisting", params);
        },
        preview: function (params){
              $state.go("main.preview", params);
        },
        pay: function (params){
              $state.go("main.pay", params);
        },
        // getStarted: function () {
        //     $state.go('dashboard.getstarted',{});
        // },    
        info: function (params) {
            $state.go('dashboard.info', Models.Info(params));
        },
        forgotPassword: function(params){
            $state.go('main.forgotPassword', params);
        },
        admin: function(){
            $state.go('main.admin');
        },        
        // admin: function (userType) {
        //   if (userType == "staff"){            
        //     $state.go('dashboard.staffhome',{});
        //   }else if (userType == "admin"){            
        //     $state.go('dashboard.adminhome',{});
        //   }else if (userType == "superadmin"){            
        //     $state.go('dashboard.superadminhome',{});
        //   }else{
        //     go();
        //   }
        // },    
        profile: function (id) {
            $state.go('dashboard.profile',{id: id}, {reload: true});
        },

        tou: function () {
            go("termsofuse"); 
        }
    };
}
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('Models', factory);

  /** @ngInject */
  function factory() {

      var Company = function (options) {
          options = options || {};
          this.companyType = "";

          this.name = options.name || "";
          this.description = "";
          this.logo = options.logo || "";
          this.geoPoint = "";
          this.url = "";
          this.phone = "";

          this.address = ";"
          this.city = "";
          this.state = "";
          this.zip = "";
          this.country = "";
      }

      var Industry = function () {  //Eg. Healthcare, Beauty, Wellness, etc
          this.name = "";
      }

      var Vertical = function () {  //Eg. Specific vertical under each industry... Healthcare, Beauty, Wellness, etc
          this.name = "";
      }

      var Listing = function () {
          this.industry = ""; //IT, Hospitality
          this.vertical = ""; //programming, design, sys admin, etc

          this.companyString = ""; //Company name as string
          this.company = ""; //Company
          this.user = ""; //User

          this.title = "";
          this.description = "";
          this.additionalInfo = "";
          this.amountInfo = ""; //to handle salary, costs, etc
          this.listingType = "";
          this.views = 0;

          //Location
          //this.geoPoint = new Parse.GeoPoint();
          // this.address = "";
          // this.city = "";
          // this.state = "";
          // this.country = "";

          this.featured = false; //true/false
          this.expiresDate = "";
          this.status = "active"; //expiring, expired
      }

      var ListingInteraction = function(){ //Who's applied to what
        //id
        this.user = "";
        this.listing = "";
        this.company = ""; //to track who's appied or shown interest in company
      }

      var JobListing = function () {
          //this.compensation = "";
          //this.jobType = ""; //parttime, fulltime, contractor remote/telecommute?
          //this.requiredSkills = "";
      }
      JobListing.prototype = new Listing();

      var CourseListing = function () {
      }

      var CompanyListing = function () {
      }

      var User = function (userType) {
          this.company = "";
          this.username = "";
          this.email = "";
          this.password = "";

          this.firstName = "";
          this.lastName = "";
          this.gender = ""; //male, female, trans male, trans female, other
          this.cellPhone = "";
          this.phoneNumber = "";
          this.admin = false;
          //this.pw = "";
         // this.pwconfirm = "";
          //this.userType = userType || ""; //manager
          this.availability = true; // ability to hide or unhide from searches, employers
          this.availableOnDemand = false;
          this.urgentJobsContact = "";

          //Address
          this.address = "";
          this.city = "";
          this.state = "";
          this.zipCode = "";
          this.country = "";

      }

      var JobPreferences = function(){
        this.travelMileage = "";
        this.minimumHourlyRate = "";
        this.employmentPreference = "";//fill-in jobs, temp/perm jobs
      }

      var Credentials = function(){
        this.licenseState = "";
        this.licenseNumber = "";
        this.licenseExpirationMonth = "";
        this.licenseExpirationYear = "";

        this.insuranceProvider = "";
        this.insuranceExpirationMonth = "";
        this.insuranceExpirationYear = "";

        this.healthInsuranceCarrier = "";
        this.claimsNumber = "";
      }

      var ProfessionalInformation = function(){
        this.resume = "";
        this.schoolInfo = "";
        this.graduationMonth = "";
        this.graduationYear = "";
        this.otherEducation = "";
        this.personalStatement = "";

      }

      var EmploymentInfo = function(){ //array of employment
        this.company = "";
        this.address = "";
        this.city = "";
        this.state = "";
        this.country = "";
        this.dateFrom = "";
        this.dateTo = "";
        this.position = "";
        this.supervisor = "";
        this.duties = "";
        this.rateSalary = "";
        this.reasonForLeaving= "";
      }

      var UserProfile = function(user){
        this.user = user || "";
        this.professionalInformation = new ProfessionalInformation();
        this.jobPreference = new JobPreferences();
        this.credentials = new Credentials();
        this.employmentHistory = [new EmploymentInfo()];//of employmentInfo
        this.skills = [];
      }


      //******* PAYMENTS *******




      /*********** UTILITY MODELS ********/
      var Email = function(){
        this.from = "";
        this.to = "";
        this.subject = "";
        this.html = "";
      }

      var Info = function(options){
        this.pageTitle = options.pageTitle || "";
        this.title = options.title || "";
        this.messageType = options.messageType || "";
        this.subTitle = options.subTitle || "";
        this.description = options.description || "";
        this.link = options.link || "";
        this.linkText = options.linkText || "";
      }




      return {
          User: function (userType) { return new User(userType); },
          Company: function () { return new Company(); },
          Industry: function () { return new Industry(); },
          Vertical: function () { return new Vertical(); },
          Listing: function () { return new Listing(); },
          ListingInteraction: function () { return new ListingInteraction(); },
          JobListing: function () { return new JobListing(); },
          CourseListing: function () { return new CourseListing(); },
          CompanyListing: function () { return new CompanyListing(); },
          UserProfile: function (user) { return new UserProfile(user); },

          Email: function () { return new Email(); },
          Info: function (options) { return new Info(options); },
      }
  }
})();


(function() {
  'use strict';

  angular
    .module('app')
    .factory('LocaleService', factory);

  /** @ngInject */
  function factory(moment) {

     return {
        getCurrentLocale: function(callback){
          $.getJSON('http://ipinfo.io', function(data){
            console.log(data)

            if (callback){
              callback(data);
            }
          });        
        }
     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('LocalStorage', factory);

  /** @ngInject */
  function factory(AppSettings) {

      var keyPrefix = AppSettings.getAppTitle();

      function getKey(key){
          //return DigitalFio.getEnvKeys().env + "-" + keyPrefix + "-" + key;
          return keyPrefix + "-" + key;
      }

      return {
          user: function (user) {

              if (!user) {
                  return amplify.store(getKey("user")); 
              }

              amplify.store(getKey("user"), user);
          },
          company: function (co) {
              if (!co) {
                  return amplify.store(getKey("company"));
              }

              amplify.store(getKey("company"), co);
          },
          states: function (states) {
              if (!states) {
                  return amplify.store(getKey("states"));
              }

              amplify.store(getKey("states"), states);
          },

          settings: function (settings) {
              if (!settings) {
                  return amplify.store(getKey("settings"));
              }

              amplify.store(getKey("settings"), settings);
          },
          clearData: function () {
              amplify.store(getKey("company"), null);
              amplify.store(getKey("user"), null);
              //amplify.store(getKey("company"), null);
              //amplify.store(getKey("company"), null);

          }
      };
    }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('Loader', factory);

  /** @ngInject */
  function factory() {


      var loader = angular.element("body");
        //$submitBtns = $("input[type='button']");
    return {
        show: function () {
            loader.addClass("show-loader");
            //$submitBtns.attr("disabled","disabled");
        },
        hide: function () {
            loader.removeClass("show-loader");
            //$submitBtns.removeAttr("disabled");
        },
    };

  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .factory('XIdentityX', factory);

  /** @ngInject */
  function factory($rootScope, DataService) {

      function errorHandler(data, parseError){
            console.log("****   PARSE ERROR *****");
            console.log(data, parseError);
          }
   
      function getUserById(id, success){
        var userQuery = DataService.User().parseQuery;
        userQuery.include("company");

        userQuery.get(id, {
            success: function(result){
              var user = result;
              var company = user.get("company");

              $rootScope.parseUser = user;
              if(company)
              {
                $rootScope.parseCompany = company;
              }

              var loggedInUser = {
                    id: user.id,
                    firstName: user.get("firstName"),
                    lastName: user.get("lastName"),
                    email: user.get("email"),

                    company: {
                     id: company.id,
                     name: company.get("name"),
                     city: company.get("city")
                     },
                     parseCompany: company
              }
            $rootScope.loggedInUser = loggedInUser;
            success();
            },
            error: function(dataObject, parseError){
              errorHandler(dataObject, parseError);
            }
          });
      };

      return {
          flexUserInfo: function(){
            if(Session.currentUser()){

              getUserById(Session.currentUser().id, function()
              {
                $rootScope.$apply();
              });
            }
          },
          user: function(){
            if ($rootScope.loggedInUser){
              return $rootScope.loggedInUser;
            }

            if(Session.currentUser()){

              getUserById(Session.currentUser().id, function()
              {
                $rootScope.$apply();
              });
            }
          }
        }
    };
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('EventService', factory);

  /** @ngInject */
  function factory(rootScope) {

  		function broadcast(event, data){
  			//DigitalFio.log("EVENT - " + event, data);
  			$rootScope.$broadcast(event, data);
  		}

        var eventService = {
        	// updateUserList : function(){ broadcast("updateuserlist"); },
        	// newTaskCreated : function(){ broadcast("newtaskcreated"); },
         //  updateTaskCount : function(data){ broadcast("updatetaskcount", data); },
         //  statusUpdated : function(data){ broadcast("statusupdated", data); },
         //  moodSelected : function(data){ broadcast("moodselected", data); },

        };

        
     

         return eventService;
      }
})();


(function() {
  'use strict';

  angular
    .module('app')
    .factory('DummyContent', factory);

  /** @ngInject */
  function factory(Loader) {

    function getContent(type, obj){

      switch (type){

        case "user":
          return {
            firstName : "Noah",
            lastName : "Addy",
            email : "noahaddy@gmail.com",
            username : "noahaddy@gmail.com",
            password : "password"
          }
         break;

        case "company":
          return {
            name : "Digital Fio",
            url : "www.digitalfio.com",
            description: "We're a locally owned and operated business. We rock!",
            logo : undefined,
            listingType: "",
            address : "123 Main Ave",
            city : "Seattle",
            state : "WA",
            zipCode: "98101"
          }
          break;

        case "joblisting":
          return {
            title : "Massage Therapist",
            description : "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde ipsum facilis odit, possimus magnam adipisci non, ut, maxime quaerat aut quas dicta incidunt maiores iusto ea officia necessitatibus error. Facere non dolores nostrum ducimus voluptatibus reprehenderit praesentium minima sed! Dolorum earum beatae nobis et impedit ea maxime ab itaque repudiandae.",
            compensation : "$25.00/hr",
            views: 0,
            city : "Seattle",
            state : "WA"
          }
          break;

        case "listing":
          return {
            title : "Massage Therapist",
            description : "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde ipsum facilis odit, possimus magnam adipisci non, ut, maxime quaerat aut quas dicta incidunt maiores iusto ea officia necessitatibus error. Facere non dolores nostrum ducimus voluptatibus reprehenderit praesentium minima sed! Dolorum earum beatae nobis et impedit ea maxime ab itaque repudiandae. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde ipsum facilis odit, possimus magnam adipisci non, ut, maxime quaerat aut quas dicta incidunt maiores iusto ea officia necessitatibus error. Facere non dolores nostrum ducimus voluptatibus reprehenderit praesentium minima sed! Dolorum earum beatae nobis et impedit ea maxime ab itaque repudiandae.",
            compensation : "$25.00/hr",
            views: 0,
            city : "Seattle",
            state : "WA"
          }
          break;

          case "userprofile":

          return {
            professionalInformation: {
                resume : "",
                schoolInfo : "School Lorem ipsum",
                graduationMonth : " graduationMonthLorem ipsum",
                graduationYear : "graduationYear Lorem ipsum",
                otherEducation : "otherEducation Lorem ipsum",
                personalStatement : "personalStatement Lorem ipsum",
            },
            jobPreference: {
              travelMileage : "",
              minimumHourlyRate : "minimumHourlyRate Lorem ipsum",
              employmentPreference : "",//fill-in jobs, temp/perm jobs
            },
            credentials: {
              licenseState : "",
              licenseNumber : "licenseNumber Lorem ipsum",
              licenseExpirationMonth : "",
              licenseExpirationYear : "",

              insuranceProvider : "insuranceProvider Lorem ipsum",
              insuranceExpirationMonth : "",
              insuranceExpirationYear : "",

              healthInsuranceCarrier : "healthInsuranceCarrier Lorem ipsum",
              claimsNumber : "claimsNumber Lorem ipsum",
            },
            employmentHistory: [{
              company : "company Lorem ipsum",
              address : "address Lorem ipsum",
              city : "city Lorem ipsum",
              state : "state Lorem ipsum",
              country : "",
              dateFrom : "",
              dateTo : "",
              position : "position Lorem ipsum",
              supervisor : "supervisor Lorem ipsum",
              duties : "duties Lorem ipsum",
              rateSalary : "rateSalary Lorem ipsum",
              reasonForLeaving: "reasonForLeaving Lorem ipsum",
            }],
            skills: []
          }
          break;

        default:
          return {};

      }
    }
   

     return {
        get: getContent
     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('DropdownContent', factory); 

  /** @ngInject */
  function factory(Loader) {
        
        function get(text, value){
          if(!value){
            if(text.constructor === Array){
              return text.map(function(t){
                return { text: t, value: t};
              });
            }
            return { text: text, value: text};
          }
          return { text: text, value: value};
        }

     return {
        gender: function(){ 
          return get([ "Male", "Female", "Trans Male", "Trans Female", "other"]);

      },
        urgentJobs:function(){ return [
          get("Text message to my cell phone"),
          get("Phone call to my primary phone")
        ]},
        employmentTypes:function(){ 
          return [
          get("Fill-in jobs"),
          get("Temp/Permanent jobs")
        ]
      },
        mileage : function(){ return [
        get("3 miles"),
        get("5 miles"),
        get("10 miles"),
        get("25 miles"),
        get("50 miles"),
        ]
      },
        

     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('DateHelper', factory);

  /** @ngInject */
  function factory(moment) {

     return {
      //   get: function(){
      // console.log("----> moment: ", moment.monthsShort().map(function(mth){
      //       return { text: mth, value: mth};
      //     }));
        
      //   },
        monthsShort: function(){
          return moment.monthsShort().map(function(mth){
            return { text: mth, value: mth};
          });
        },
        get10YearsFromNow: function(){
          var currYear = new Date().getFullYear();
          var years = [];

          for(var i = 0; i < 10; i++){
            years.push(currYear++);
          }
          return years.map(function(str){
            return { text: str.toString(), value: str};
          });
        },
        getGraduationYears: function(){ //From 1970 to 6 years from now..
          var startingYear = 1970;
          var endYear = new Date().getFullYear() + 6;
          var years = [];

          for(var i = startingYear; i <= endYear; i++){
            years.push(i);
          }
          return years.map(function(str){
            return { text: str.toString(), value: str};
          });
        }
     } 
  }
  
})();

(function() {
  'use strict';

 

  angular
    .module('app')
    .factory('DataService', factory);

  /** @ngInject */
  function factory(Loader, DataParser) {

    var Repo = function(tableName){
        this.tableName = tableName;
        this.parseClass = Parse.Object.extend(this.tableName);
        this.parseObject = new this.parseClass();
        this.parseQuery = new Parse.Query(this.tableName);        
    }

    Repo.prototype.getById = function (id, successCallback, errorCallback) {
      var that = this;
      this.parseQuery.get(id, {
        success: function(result){
          _successHandler(that._parseResults(result), successCallback);
        },
        error: function(dataObject, parseError){ // error is a Parse.Error with an error code and message.
            _errorHandler(dataObject, parseError, errorCallback);
        }
      });
    };

    Repo.prototype.getAll = function (successCallback, errorCallback) {
      var that = this;

      this.parseQuery.find({
        success: function(result){
          _successHandler(that._parseResults(result), successCallback);
        },
        error: function(dataObject, parseError){ // error is a Parse.Error with an error code and message.
            _errorHandler(dataObject, parseError, errorCallback);
        }
      });
    };

    Repo.prototype.getByParams = function (params, successCallback, errorCallback) {
      var that = this;

      for (var key in params){

        if(key == "include"){
          processIncludes(params[key]);
          continue;
        }

        if(params[key]){
          this.parseQuery.equalTo(key, params[key]);
        }
      }

      function processIncludes(includeString){
        var includeArray = includeString.split(",").map(function(str){
          return str.trim();
        });

        includeArray.forEach(function(str){
          that.parseQuery.include(str);
        });
      }

      this.parseQuery.find({
        success: function(result){
          _successHandler(that._parseResults(result), successCallback);
        },
        error: function(dataObject, parseError){ // error is a Parse.Error with an error code and message.
            _errorHandler(dataObject, parseError, errorCallback);
        }
      });
    };

    Repo.prototype.save = function (data, successCallback, errorCallback) {
      var that = this;
      Loader.show();
      console.log("...saving data...", data);

      if(data.parseObject){ //remove any handing parse objects from data retrieval conversion/parsing...
        delete data.parseObject;
      }

      this.parseObject.save(data, {
        success: function(result){
          _successHandler(that._parseResults(result), successCallback);
        },
        error: function(dataObject, parseError){ // error is a Parse.Error with an error code and message.
            _errorHandler(dataObject, parseError, errorCallback);
        }
      });
    };

     Repo.prototype.update = function (data, success, error) {
      //TODO: Noah
    }

    Repo.prototype.remove = function (data, success, error) {
        //TODO: Noah
    }

     Repo.prototype._parseResults = function(data){
        var that = this;
        var results;

        function logger(data){
          console.info("**** data logger *****", data);
          return data;
        }

        if(data.constructor === Array){
          return logger(data.map(__parseObject))
        }else{
          return logger(__parseObject(data));
        }

        function __parseObject(obj){
              return DataParser.parse(that.tableName, obj);

        }
    }

    //********** Helper functions ***********
    function _successHandler(results, successCallback){
          Loader.hide();
          //TODO: process data?
          if(successCallback){

            successCallback(results);
          }
    }

    function _errorHandler(dataObject, parseError, errorCallback){
          Loader.hide();
          //Notifier.error({message: "An error occured. Please refresh and try again or contact administrator."})
          console.log(dataObject);
          console.log(parseError);

          if(errorCallback){
            errorCallback(dataObject);
          }
    }
    //********** End Helper functions ***********

     return {
        User:  function(){ return new Repo("User"); },
        Country: function(){ return new Repo("Country"); },
        State: function(){ return new Repo("State"); },
        Industry: function(){ return new Repo("Industry"); },
        Vertical: function(){ return new Repo("Vertical"); },
        ProfessionalSkill: function(){ return new Repo("ProfessionalSkill"); },

        ListingType: function(){ return new Repo("ListingType"); },
        AccountType: function(){ return new Repo("AccountType"); },

        Company: function(){ return new Repo("Company"); },
        UserProfile: function(){ return new Repo("UserProfile"); },
        Listing: function(){ return new Repo("Listing"); },
        ListingInteraction: function(){ return new Repo("ListingInteractions"); },

     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('DataSeed', factory);

  /** @ngInject */
  function factory(DataService) {


var countries = [
  {
    name: "Canada", stateTerm: "Province",
    states : [
    {
          "name":"Alberta",
          "code":"AB"
        },
        {
          "name":"British Columbia",
          "code":"BC"
        },
        {
          "name":"Manitoba", 
          "code":"MB"
        },
        {
          "name":"New Brunswick",
          "code":"NB"
        },
        {
          "name":"Newfoundland",
          "code":"NL"
        },
        {
          "name":"Northwest Territories",
          "code":"NT"
        },
        {
          "name":"Nova Scotia",
          "code":"NS"
        },
        {
          "name":"Nunavut",
          "code":"NU"
        },
        {
          "name":"Ontario",
          "code":"ON"
        },
        {
          "name":"Prince Edward Island",
          "code":"PE"
        },
        {
          "name":"Quebec",
          "code":"QC"
        },
        {
          "name":"Saskatchewan",
          "code":"SK"
        },
        {
          "name":"Yukon Territory",
          "code":"YT"
        }
      ]
  },
  { name: "USA", stateTerm: "State",
    states : [
    {
        "name": "Alabama",
        "code": "AL"
    },
    {
        "name": "Alaska",
        "code": "AK"
    },
    {
        "name": "American Samoa",
        "code": "AS"
    },
    {
        "name": "Arizona",
        "code": "AZ"
    },
    {
        "name": "Arkansas",
        "code": "AR"
    },
    {
        "name": "California",
        "code": "CA"
    },
    {
        "name": "Colorado",
        "code": "CO"
    },
    {
        "name": "Connecticut",
        "code": "CT"
    },
    {
        "name": "Delaware",
        "code": "DE"
    },
    {
        "name": "District Of Columbia",
        "code": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "code": "FM"
    },
    {
        "name": "Florida",
        "code": "FL"
    },
    {
        "name": "Georgia",
        "code": "GA"
    },
    {
        "name": "Guam",
        "code": "GU"
    },
    {
        "name": "Hawaii",
        "code": "HI"
    },
    {
        "name": "Idaho",
        "code": "ID"
    },
    {
        "name": "Illinois",
        "code": "IL"
    },
    {
        "name": "Indiana",
        "code": "IN"
    },
    {
        "name": "Iowa",
        "code": "IA"
    },
    {
        "name": "Kansas",
        "code": "KS"
    },
    {
        "name": "Kentucky",
        "code": "KY"
    },
    {
        "name": "Louisiana",
        "code": "LA"
    },
    {
        "name": "Maine",
        "code": "ME"
    },
    {
        "name": "Marshall Islands",
        "code": "MH"
    },
    {
        "name": "Maryland",
        "code": "MD"
    },
    {
        "name": "Massachusetts",
        "code": "MA"
    },
    {
        "name": "Michigan",
        "code": "MI"
    },
    {
        "name": "Minnesota",
        "code": "MN"
    },
    {
        "name": "Mississippi",
        "code": "MS"
    },
    {
        "name": "Missouri",
        "code": "MO"
    },
    {
        "name": "Montana",
        "code": "MT"
    },
    {
        "name": "Nebraska",
        "code": "NE"
    },
    {
        "name": "Nevada",
        "code": "NV"
    },
    {
        "name": "New Hampshire",
        "code": "NH"
    },
    {
        "name": "New Jersey",
        "code": "NJ"
    },
    {
        "name": "New Mexico",
        "code": "NM"
    },
    {
        "name": "New York",
        "code": "NY"
    },
    {
        "name": "North Carolina",
        "code": "NC"
    },
    {
        "name": "North Dakota",
        "code": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "code": "MP"
    },
    {
        "name": "Ohio",
        "code": "OH"
    },
    {
        "name": "Oklahoma",
        "code": "OK"
    },
    {
        "name": "Oregon",
        "code": "OR"
    },
    {
        "name": "Palau",
        "code": "PW"
    },
    {
        "name": "Pennsylvania",
        "code": "PA"
    },
    {
        "name": "Puerto Rico",
        "code": "PR"
    },
    {
        "name": "Rhode Island",
        "code": "RI"
    },
    {
        "name": "South Carolina",
        "code": "SC"
    },
    {
        "name": "South Dakota",
        "code": "SD"
    },
    {
        "name": "Tennessee",
        "code": "TN"
    },
    {
        "name": "Texas",
        "code": "TX"
    },
    {
        "name": "Utah",
        "code": "UT"
    },
    {
        "name": "Vermont",
        "code": "VT"
    },
    {
        "name": "Virgin Islands",
        "code": "VI"
    },
    {
        "name": "Virginia",
        "code": "VA"
    },
    {
        "name": "Washington",
        "code": "WA"
    },
    {
        "name": "West Virginia",
        "code": "WV"
    },
    {
        "name": "Wisconsin",
        "code": "WI"
    },
    {
        "name": "Wyoming",
        "code": "WY"
    }

]
}];



    function seedCountries () {
      countries.forEach(function(country){
          DataService.Country().save({name: country.name, stateTerm: country.stateTerm }, 
            function(ctry){
            	console.log("country data saved");

              country.states.forEach(function (state) {
                  state.countryId = ctry.id;
                  DataService.State().save(state, function(){
                  	console.log("state data saved");
                  }, 
                    function(err){
                      console.log(err);
                  }
                );
              });
          }, 
          function(data, error){} );
      });   

    }

    function seedIndustries(){
      var industries = [
        {
          name: "Wellness",
          verticals: ["Massage", "Fitness"]
        },
        {
          name: "Beauty & Cosmetology",
          verticals: ["Hair", "Make-up", "Pedicure, Manicure & Nails", "Waxing & Skin care"]
        }
      ];

      industries.forEach(function(industry){
          DataService.Industry().save({ name: industry.name },function(ind){
          	console.log("industry data saved");

            industry.verticals.forEach(function (vertical) {
                  var vert = {
                    name: vertical,
                    industry: ind
                  };

                  DataService.Vertical().save(vert, function(){
                  	console.log("vertical data saved");
                  }, 
                     function(data, err){
                      console.log(err);
                    }
                  );
                });
          },
         function(data, err){
            console.log(err);
          }
        );
      });

      function saveVertical(industry){

      }
    }

    function seedAccountTypes(){
      var accountTypes = [
        { name: "Employer", type:"employer", description: "Companies, Spas, Resorts, etc"},
        { name: "Education Provider", type:"education",  description: "Schools, Continuing Education Providers, Licensing Providers, etc"},
      ];

      accountTypes.forEach(function(acctType){
          DataService.AccountType().save(acctType, function(acctType){
            console.log("accountType data saved");

          },
         function(data, err){
            console.log(err);
          }
        );
      });
    }


    function seedListingTypes(){
      var listingTypes = [
        { name: "Job Listing", description: "Listing job positions, licensed professionals, contractors, etc", type:"job", pricePerListing: 65.00, duration: 30 }, //duration in days
        { name: "Course Listing", description: "Listing for Continuing education classes, courses, certification classes, etc", type:"course", pricePerListing: 65.00, duration: 30 },
        { name: "Company Listing", description: "Listing to highlight your company to gain some visibility ", type:"company", pricePerListing: 65.00, duration: 30 },
        { name: "Product Listing", description: "Listing for your products, goods, services, etc", type:"product" ,pricePerListing: 95.00, duration: 30 },
        { name: "Banner Ad Listing", description: "Listing to get featured in our banner ad sections", type:"banner", pricePerListing: 100.00, duration: 7 },
      ];
      
      listingTypes.forEach(function(obj){
          DataService.ListingType().save(obj, function(data){
            console.log("listingtype data saved");

          },
         function(data, err){
            console.log(err);
          }
        );
      });
    }

    function seedProfessionalSkills(){
      var skills = [ 
      "Acupressure", 
      "Chair Massage", 
      "Cranio-Sacral", 
      "Deep Tissue", 
      "Hellerwork", 
      "Hot Stone", 
      "Japanese", 
      "Massage", 
      "Medical", 
      "Massage", 
      "Myofascial Release", 
      "Neuromuscular Therapy", 
      "Pregnancy Massage", 
      "Reflexology", 
      "Reiki", 
      "Rolfing", 
      "Shiatsu", 
      "Sports Massage", 
      "Structural Integration", 
      "Swedish", 
      "Thai Massage"
      ];
      
      skills.forEach(function(skill){
          DataService.ProfessionalSkill().save({vertical: "", verticalCode: "massage", skill: skill}, function(data){
            console.log("skills data saved");

          },
         function(data, err){
            console.log(err);
          }
        );
      });
    }

    function seed(){
        console.log("calling seed..."); 
       //seedCountries();
        //seedIndustries();
        //seedListingTypes();
        //seedAccountTypes();
        //-- moved to dropdown data service -- seedProfessionalSkills();
    }
   

     return {
        seed: seed
     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('DataParser', factory);

  /** @ngInject */
  function factory() {

      function company(obj){
         return {
                  id: obj.id,
                  name: obj.get("name"),
                  description: obj.get("description"),
                  url: obj.get("url"),
                  phone: obj.get("phone"),
                  address: obj.get("address"),
                  city: obj.get("city"),
                  state: obj.get("state"),
                  zipCode: obj.get("zipCode"),
                  //x: obj.get("x"),
                  //country: obj.get("country"),
                  //: obj.get(""),
                  parseObject: obj //Hold on to the original parse object
                }
      }

      function user(obj){
        return {
                  id: obj.id,
                  firstName: obj.get("firstName"),
                  lastName: obj.get("lastName"),
                  //email: obj.get("email"),
                  phoneNumber: obj.get("phoneNumber"),
                  cellPhone: obj.get("cellPhone"),

                  address: obj.get("address"),
                  city: obj.get("city"),
                  state: obj.get("state"),
                  zipCode: obj.get("zipCode"),
                  gender: obj.get("gender"), 
                  availability: obj.get("availability"),
                  availableOnDemand: obj.get("availableOnDemand"),
                  urgentJobsContact: obj.get("urgentJobsContact"),
                  //x: obj.get("x"),
                  //country: obj.get("country"),
                  //: obj.get(""),
                  parseObject: obj //Hold on to the original parse object
                }
      }

      function accountType(obj){
        return {
                  id: obj.id,
                  name: obj.get("name"),
                  description: obj.get("description"),
                  type: obj.get("type"),
                  parseObject: obj //Hold on to the original parse object
                }
      }

      function listingType(obj){
        return {
                  id: obj.id,
                  name: obj.get("name"),
                  type: obj.get("type"),
                  description: obj.get("description"),
                  pricePerListing: obj.get("pricePerListing"),
                  duration: obj.get("duration"),
                  parseObject: obj //Hold on to the original parse object
                }
      }

      function listing(obj){
        return {
                  id: obj.id,
                  title: obj.get("title"),
                  description: obj.get("description"),
                  company: obj.get("company"),
                  companyString: obj.get("companyString"),
                  amountInfo: obj.get("amountInfo"),
                  listingType: obj.get("listingType"),
                  views: obj.get("views"),
                  // TODO: Phong: load city and state following geoPoint or Company
                  // geoPoint = object.get("geoPoint"),
                  // city: object.get("city"),
                  // state: object.get("state"),
                  city: 'Seattle',
                  state: 'WA',
                  featured: obj.get("featured"),
                  createdAt: obj.get("createdAt"),
                  parseObject: obj //Hold on to the original parse object
                }
      }

      function listingInteraction(obj){
        return {
                  id: obj.id,
                  listing: obj.get("listing"),
                  user: obj.get("user"),
                  parseObject: obj //Hold on to the original parse object
                }
      }

      function professionalInformation(obj){
        return {

        }
      }

      function jobPreference(obj){
        return {

        }
      }

      function credentials(obj){
        return {

        }
      }

      function employmentHistory(obj){
        return {

        }
      }

      function skills(obj){
        return {

        }
      }

      function userProfile(obj){
        return {
          id: obj.id,
          professionalInformation : obj.get("professionalInformation"),
          jobPreference : obj.get("jobPreference"),
          credentials : obj.get("credentials"),
          employmentHistory : obj.get("employmentHistory"),
          skills : obj.get("skills"),

        }
      }

      // function user(obj){
        
      // }

      // function user(obj){
        
      // }


     return {
        parse: function(tableName, data){
                switch (tableName){
                case "Company":
                  return company(data);
                  break;

                case "User":
                  return user(data);
                  break;

                case "AccountType":
                  return accountType(data);
                  break;

                case "ListingType":
                  return listingType(data);
                  break;

                case "Listing":
                  return listing(data);
                  break;

                case "ListingInteraction":
                  return listingInteraction(data);
                  break;

                case "UserProfile":
                  return userProfile(data);
                  break;

                case "Company":
                  return company(data);
                  break;

            default:
            return { id: data.id, parseObject: data };

                }  
        }
     } 
  }
  
})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('AppSettings', factory);

  /** @ngInject */
  function factory() {

      var settings = {

        title: { t1: "Find", t2: "Touch"},
        version: 1, 
        
        currentEnvironment: "DEV", //TEST, PROD,
        environments: { 
            DEV: {  
              env: "DEV", 
              url: "https://test-firebun.azure-mobile.net/", 
              key: "",
              email: "", 
              fromEmail: "",
              websiteDomain: "http://127.0.0.1:9000", 
            },
            PROD: {  
              env: "PROD", 
              url: "", 
              key: "", 
              email: "",
              fromEmail: "",
              websiteDomain: "",
            }, 
          },

          getAppTitle: function(){
            return this.title.t1 + this.title.t2 || "";
          } 
      };

   
    return settings;
  }
    
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, StateHelperProvider) { //
    // var parentState = {
    //   name: "main",
    //   url: "/",
    //   templateUrl: 'app/main/main.html',
    //   controller: 'MainController',
    //   controllerAs: 'vm'
    // };

    

    $stateProvider
      .state(StateHelperProvider.states.main)
      // .state('main', {
      //   url: '/',
      //   templateUrl: 'app/main/main.html',
      //   controller: 'MainController',
      //   controllerAs: 'vm'
      // })
      // .state('main.home', {
      //   url: '^/home',
      //   templateUrl: 'app/main/v-home.html',
      //   controller: 'HomeController',
      //   controllerAs: 'vm'
      // })
      .state('home', {
        url: '^/home',
        templateUrl: 'app/main/v-home.html',
        controller: 'HomeController',
        controllerAs: 'vm',
        parent: StateHelperProvider.states.main,
     })
      .state('styleguide', {
        url: "^/styleguide",
        templateUrl: "app/main/styleguide.html",
        parent: StateHelperProvider.states.main
        })
      ;
      

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('StyleGuideController', controller);

  /** @ngInject */
  function controller($scope) {
   var vm = this;

    init();

    function init() {
      //vm.standardGrays =  ['aaa', 'bbb, 'ccc', 'ddd', ''eee, '111', '333', '444', '555', '555', '666', '777', '888', '999'];
  }


  // $scope.$on("$viewContentLoaded", function(){
  //   $(document).foundation();
  // });
}
})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('MainController', controller);

  /** @ngInject */
  function controller($scope, $timeout, Nav) {
   var vm = this,
   $rotator;

    init();

    function init() {
 
  }
 

  $scope.$on('$viewContentLoaded', function () {
    $timeout(function() { 
         $(document).foundation();

          $rotator = $(".rotator");
            $rotator.slick({
                     arrows: false,
                     autoplay: true,
                      autoplaySpeed: 5000, //5000
                      speed: 1000,
                      fade: true,
                      dots: true,
            });
      });
  });
}

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('HomeController', controller);

  /** @ngInject */
  function controller($scope, Unsplash) {
   var vm = this;

    init();

    function init() {
      console.log("init from main");

    // console.log("unsplash one ---->", Unsplash.one('tCICLJ5ktBE'));
    //vm.hero1 = Unsplash.getAnimated('tCICLJ5ktBE');
    //vm.camera = Unsplash.getAnimated('6UJ-a8983DI'); //tBtuxtLvAZs //1z1F5Qc30Bs //gttaJxTwyZM //6UJ-a8983DI

    //vm.one = Unsplash.one('1z1F5Qc30Bs'); //1z1F5Qc30Bs  
  }


  // $scope.$on("$viewContentLoaded", function(){
  //   $(document).foundation();
  // });
}
})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, Session, DataSeed) {


    $log.debug('runBlock end'); //debug, error, info, warn
    //Session.init();

    //DataSeed.seed();
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/home');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('moment', moment); 

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<section class=\"app-container\"><app-navbar2></app-navbar2><div ui-view=\"\"></div></section>");
$templateCache.put("app/main/styleguide.html","<section class=\"full-pane\"><action-header ttl=\"\'Style Guide & Themes\'\" cssclass=\"\" actions=\"\"></action-header><div class=\"page-content\"><br><br><br><br><app-section ttl=\"\'Color Palette\'\"><div class=\"row\"><div class=\"columns\"><div class=\"theme-palette bg-theme\">Theme Primary</div></div><div class=\"columns\"><div class=\"theme-palette bg-theme-secondary\">Theme Secondary</div></div><div class=\"columns\"><div class=\"theme-palette accent-1\">Accent - 1</div></div><div class=\"columns\"><div class=\"theme-palette accent-2\">Accent - 2</div></div><div class=\"columns\"><div class=\"theme-palette accent-3\">Accent - 3</div></div></div></app-section><app-section ttl=\"\'Typography\'\"><div class=\"row\"><div class=\"columns\"><p>Theme Copy</p></div><div class=\"columns\"><p class=\"theme-copy-secondary\">Theme Copy Secondary</p></div><div class=\"columns\"><h3 class=\"section-title\">Section Titles</h3></div><div class=\"columns\"><h3 class=\"section-sub-title\">Section Sub Titles</h3></div><div class=\"columns\"><p>Body Copy</p></div></div><div class=\"row\"><div class=\"column\"><div class=\"heading-xxlarge\">Heading XL</div></div><div class=\"column\"><div class=\"heading-large\">Heading large</div></div><div class=\"column\"><div class=\"heading-medium\">Heading medium</div></div><div class=\"column\"><div class=\"heading-small\">Heading small</div></div></div></app-section><app-section ttl=\"\'Forms and Inputs\'\"><div class=\"row\"><div class=\"columns\"><a href=\"\" class=\"button\">Button</a></div><div class=\"columns\"><a href=\"\" class=\"button primary\">Button Primary</a></div><div class=\"columns\"><a href=\"\" class=\"button secondary\">Button Secondary</a></div><div class=\"columns\"><a href=\"\" class=\"button invert\" style=\"outline:1px solid #eee;\">Button Inverted</a></div><div class=\"columns\"><a href=\"\" class=\"button ghost\">Button Ghost</a></div><div class=\"columns\"><a href=\"\" class=\"button success\">Button Success</a></div><div class=\"columns\"><a href=\"\" class=\"button danger\">Button Danger</a></div><div class=\"columns\"><a href=\"\" class=\"button warning\">Button Warning</a></div></div></app-section><app-section ttl=\"\'Grays\'\"><div class=\"row\"><div class=\"columns\"><div class=\"theme-palette bg-gray\">Gray</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-light-1\">Gray Light 1</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-light-2\">Gray Light 2</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-light-3\">Gray Light 3</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-light-4\">Gray Light 4</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-dark-1\">Gray Dark 1</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-dark-2\">Gray Dark 2</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-dark-3\">Gray Dark 3</div></div><div class=\"columns\"><div class=\"theme-palette bg-gray-dark-4\">Gray Dark 4</div></div></div></app-section><app-section ttl=\"\'Other Grays\'\"><div class=\"row\" ng-init=\"other = [\'aaa\', \'bbb\', \'ccc\', \'ddd\', \'eee\', \'111\', \'333\', \'444\', \'555\', \'666\', \'777\', \'888\', \'999\']\"><div class=\"column\" ng-repeat=\"color in other\"><div class=\"theme-palette\" ng-style=\"{ \'background\': \'#{{color}}\' }\">{{color}}</div></div></div></app-section></div></section>");
$templateCache.put("app/main/v-home.html","<section class=\"rotator\" id=\"home\" data-magellan-target=\"home\"><div><app-hero klass=\"\'big-hero\'\" intro=\"\'A Kay Washington Company\'\" ttl=\"\'Bring Your Ideas to Life\'\" subtitle=\"\'Concept . Design . Manufacturing\'\" image=\"\'anim-hero-guy\'\" xunsplash=\"vm.camera\" xcta=\"\'Sign up Free\'\" animated=\"true\" cta=\"\'Contact us\'\" ctalink=\"\'mailto:kay@kdot.biz\'\"></app-hero></div><div><app-hero klass=\"\'big-hero\'\" ttl=\"\'Don\\\'t just dream it. Build it.\'\" subtitle=\"\'From Sourcing to Mass Production\'\" image=\"\'anim-hero-products\'\" xunsplash=\"vm.hero1\" xcta=\"\'Contact us\'\" animated=\"true\"></app-hero></div><div><app-hero klass=\"\'big-hero\'\" ttl=\"\'Redefine Your Image\'\" subtitle=\"\'Branding . Websites . Social Media\'\" image=\"\'animated-hero2\'\" xcta=\"\'Sign up Free\'\" animated=\"true\"></app-hero></div></section><app-section featured=\"true\" intro=\"\'What we do\'\"><div class=\"row full-widthx\"><div class=\"column small-12 large-4\"><app-contentblock ttl=\"\'BRANDING\'\" subtitle=\"\'Make a Bold Statement\'\" text=\"\'Redefine your professional look with consistent brand strategy across your physical and online profiles.\'\"></app-contentblock></div><div class=\"column small-12 large-4\"><app-contentblock ttl=\"\'INVENTION\'\" subtitle=\"\'Dream it. Build it.\'\" text=\"\'We took an idea from a concept into a product for leading luxury hotels across the globe from Dubai to New York including Trump Properties.\'\"></app-contentblock></div><div class=\"column small-12 large-4\"><app-contentblock ttl=\"\'MANUFACTURING\'\" subtitle=\"\'Sourcing & Production\'\" text=\"\'We work with leading factories across the globe to make products. Our products range from luggage solutions to security locks for POS systems.\'\"></app-contentblock></div></div></app-section><app-hero zid=\"\'buildit\'\" klass=\"\'big-hero\'\" intro=\"\'Prevent Tampering\'\" ttl=\"\'Protect Your POS Systems\'\" subtitle=\"\'By Locking your stations\'\" xcta=\"\'Learn more\'\" desc=\"\'lorem ipsum\'\" image=\"\'micros\'\" maskoptions=\"{opacity: 0.4}\"></app-hero><app-hero zid=\"\'buildit\'\" klass=\"\'big-hero\'\" intro=\"\'We Invented\'\" ttl=\"\'Cartless Housekeeping\'\" subtitle=\"\'For Luxury Hotels & Resorts\'\" cta=\"\'Visit Mobile-Pack\'\" ctalink=\"\'http://www.mobile-pack.com\'\" desc=\"\'lorem ipsum\'\" image=\"\'hero-room\'\"></app-hero><app-section zid=\"\'branding\'\" klass=\"\'bg-gray-light-4\'\" intro=\"\'Branding Strategy\'\" ttl=\"\'Stand out from the pack\'\" subtitle=\"\'A New You. A Unique Product.\'\" desc=\"\'An effective brand strategy gives you a major edge in increasingly competitive markets. But what exactly does \\\'branding\\\' mean? Simply put, your brand is your promise to your customer. It tells them what they can expect from your products and services, and it differentiates your offering from that of your competitors.\'\" featured=\"true\" lighttextx=\"true\"></app-section><app-section klass=\"\'bg-theme\'\" intro=\"\'The Photoshoot\'\" ttl=\"\'Ready for your Close-up?\'\" subtitle=\"\'Experience an Amazing Moment with our Seasoned Photographer\'\" xdesc=\"\'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam, tenetur, consequatur. Neque soluta ipsa fuga, rerum, recusandae nihil laboriosam. Eos.\'\" featured=\"true\" lighttext=\"true\"></app-section><app-hero klass=\"\'big-hero\'\" xintro=\"\'\'\" ttl=\"\'Lights. Camera. Action.\'\" subtitle=\"\'Make a bold statement\'\" xcta=\"\'Learn more\'\" image=\"\'camera\'\"></app-hero><app-section intro=\"\'Clean & Beautiful\'\" ttl=\"\'Mobile-Friendly Websites\'\" subtitle=\"\'Optimized for Desktop, Tablet & Mobile\'\" desc=\"\'\'\" featured=\"true\"></app-section><app-hero klass=\"\'big-hero \'\" intro=\"\'\'\" xttl=\"\'Website\'\" xsubtitle=\"\'Optimized for Desktop, Tablet & Mobile\'\" xcta=\"\'Learn more\'\" image=\"\'website\'\" maskoptions=\"{opacity: 0}\"></app-hero><app-hero intro=\"\'OUR EXPERTISE\'\" ttl=\"\'over 20 Years Experience\'\" subtitle=\"\'Building Brands & Products\'\" xcta=\"\'Contact us\'\"></app-hero><app-hero klass=\"\'\'\" intro=\"\'We Work with\'\" ttl=\"\'International Partners\'\" subtitle=\"\'From New York to Shanghai\'\" xcta=\"\'Contact us\'\" image=\"\'industries-hero\'\"></app-hero><app-section zid=\"\'inventors\'\" intro=\"\'Meet the team\'\" featured=\"true\" xttl=\"\'Meet The Team\'\" klass=\"\'bg-gray-light-4x\'\"><div class=\"row medium-unstack\"><div class=\"column\"><app-photo image=\"\'./assets/images/kay2.jpg\'\" ttl=\"\'KAY, Founder & CEO\'\" subtitle=\"\'Product Inventor, Manufacturing Expert, Hospitality Consulting\'\"></app-photo></div><div class=\"column\"><app-photo image=\"\'./assets/images/noah.jpg\'\" ttl=\"\'NOAH, Head of Technology\'\" subtitle=\"\'Tech Entrepreneur formerly with Industry Giants - Microsoft & Amazon Inc\'\"></app-photo></div><div class=\"column\"><app-photo image=\"\'./assets/images/xu.jpg\'\" ttl=\"\'XU, Sourcing & Manufacturing\'\" subtitle=\"\'Juan has an extensive background in mass production of Physical Goods and Assembly Line Systems\'\"></app-photo></div></div></app-section><app-section klass=\"\'bg-gray-light-3 \'\" xintro=\"\'Thank you for visiting\'\"><div class=\"row\"><div class=\"small-12 columns\"><ul class=\"small-block-grid-2 medium-block-grid-3 large-block-grid-3\"><li ng-repeat=\"link in footer.links\"><h4 class=\"footer-nav-header\">{{link.title}}</h4><a ng-repeat=\"sublink in link.sublinks\" ng-href=\"{{sublink.url}}\" target=\"_blank\">{{sublink.text}}</a></li></ul></div></div><div class=\"row medium-expand\"><div class=\"small-12 columns text-center\"><br><div class=\"company heading-medium\" style=\"max-width: 80%; margin: auto;\">\"Every great dream begins with a dreamer. Always remember, you have within you the strength, the patience, and the passion to reach for the stars to change the world.\"</div><div class=\"heading-small\"><i>By Harriet Tubman</i></div><br><a href=\"mailto:kay@kdot.biz\" class=\"button primary\">Contact us</a><div class=\"city\"></div></div></div></app-section><footer class=\"landing-footer bg-gray-dark-4\"><div class=\"row\"><div class=\"small-12 columns text-center\"><div class=\"df-marketing theme-copy-secondary\">Site Designed by Noah Addy, <strong>Digital Fio Software</strong>, Seattle</div></div></div></footer>");
$templateCache.put("app/components/Checkbox/template.html","");
$templateCache.put("app/components/ContentBlock/template.html","<section class=\"app-contentblock {{klass}}\"><div ng-transclude=\"\"></div><div class=\"title\" xng-show=\"ttl\">{{ttl || \'title\'}}</div><div class=\"sub-title\" xng-show=\"subtitle\">{{subtitle || \'subtitle\' }}</div><img ng-src=\"{{image}}\" alt=\"\" ng-show=\"image\"><p class=\"text\" xng-show=\"text\">{{text}}</p><a ng-href=\"{{ctalink}}\" class=\"button {{ctaklass}}\" ng-show=\"cta\">{{cta}}</a></section>");
$templateCache.put("app/components/Field/template.html","<section class=\"app-field\"><div class=\"row\"><div class=\"small-12 medium-4 columns\"><p class=\"field-label\">{{label}}</p></div><div class=\"small-12 medium-8 columns\"><p class=\"field-value\" ng-show=\"value\">{{value}}</p><div ng-transclude=\"\"></div></div></div></section>");
$templateCache.put("app/components/Dropdown/template.html","");
$templateCache.put("app/components/Hero/template.html","<section id=\"{{zid}}\" class=\"app-hero {{klass}} {{$root.fade}}\" ng-class=\"{\'animated-hero\' : animated, \'has-image\': image || unsplash }\" data-magellan-target=\"{{zid}}\"><div class=\"image-container\" ng-if=\"image\"><img ng-src=\"./assets/images/{{image}}-d.jpg\" alt=\"\" class=\"hero-img show-for-large\"> <img ng-src=\"./assets/images/{{image}}-t.jpg\" alt=\"\" class=\"hero-img show-for-medium-only\"> <img ng-src=\"./assets/images/{{image}}-m.jpg\" alt=\"\" class=\"hero-img show-for-small-only\"></div><div class=\"image-container\" ng-if=\"unsplash\"><img ng-src=\"{{unsplash.desktop}}\" alt=\"\" class=\"hero-img show-for-large\"> <img ng-src=\"{{unsplash.tablet}}\" alt=\"\" class=\"hero-img show-for-medium-only\"> <img ng-src=\"{{unsplash.mobile}}\" alt=\"\" class=\"hero-img show-for-small-only\"></div><div class=\"background-mask\" ng-style=\"maskoptions\"></div><div class=\"content-wrapper\"><div class=\"row\"><div class=\"column align-middle\"><div class=\"hero-text text-center\"><div ng-transclude=\"\"></div><div class=\"{{$root.anim}} _2\"><span class=\"intro-text\">{{intro}}</span></div><h2 class=\"hero-title {{$root.anim}} _4\">{{ttl}} {{boom}}</h2><h3 class=\"hero-sub-title {{$root.anim}} _6\" ng-show=\"subtitle\">{{subtitle}}</h3><a ng-href=\"{{ctalink}}\" class=\"button primary {{ctaclass}} {{$root.anim}} _8\" ng-show=\"cta\">{{cta}}</a></div></div></div></div></section>");
$templateCache.put("app/components/IconDirectives/admins.html","<div class=\"df-icon chart\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#010101\" d=\"M47,46h-1V17c0-0.552-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1v29h-4V31c0-0.552-0.447-1-1-1h-6 c-0.553,0-1,0.448-1,1v15h-4V27c0-0.552-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1v19h-4v-9c0-0.552-0.447-1-1-1H3c-0.553,0-1,0.448-1,1 v9H1c-0.553,0-1,0.448-1,1s0.447,1,1,1h2h6h6h6h6h6h6h6h2c0.553,0,1-0.448,1-1S47.553,46,47,46z M4,46v-8h4v8H4z M16,46V28h4v18H16 z M28,46V32h4v14H28z M40,46V18h4v28H40z\"></path><path fill=\"#010101\" d=\"M6,26c1.654,0,3-1.346,3-3c0-0.365-0.075-0.711-0.195-1.035l7.673-6.394C16.926,15.837,17.442,16,18,16 c0.958,0,1.803-0.46,2.353-1.161l6.653,2.216C27.036,18.683,28.365,20,30,20c1.654,0,3-1.346,3-3c0-0.543-0.156-1.046-0.41-1.486 l8.333-9.722C41.259,5.922,41.62,6,42,6c1.654,0,3-1.346,3-3s-1.346-3-3-3s-3,1.346-3,3c0,0.543,0.156,1.046,0.41,1.486 l-8.333,9.722C30.742,14.078,30.381,14,30,14c-0.958,0-1.802,0.459-2.352,1.16l-6.654-2.217C20.963,11.316,19.635,10,18,10 c-1.654,0-3,1.346-3,3c0,0.365,0.075,0.712,0.195,1.036L7.523,20.43C7.075,20.163,6.558,20,6,20c-1.654,0-3,1.346-3,3 S4.346,26,6,26z M42,2c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S41.448,2,42,2z M30,16c0.552,0,1,0.449,1,1s-0.448,1-1,1 s-1-0.449-1-1c0-0.052,0.022-0.097,0.03-0.147c0.027-0.05,0.061-0.096,0.079-0.152c0.018-0.055,0.012-0.109,0.02-0.165 C29.298,16.222,29.618,16,30,16z M18,12c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S17.448,12,18,12z M6,22 c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S5.448,22,6,22z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/badge.html","<div class=\"df-icon badge\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#231F20\" d=\"M47.543,40.463L40.53,28.335C42.095,25.575,43,22.394,43,19C43,8.523,34.477,0,24,0S5,8.523,5,19 c0,3.28,0.836,6.368,2.305,9.064l-7.17,12.399c-0.194,0.336-0.177,0.753,0.044,1.071s0.607,0.482,0.988,0.416l6.878-1.164 l2.386,6.556c0.132,0.363,0.461,0.618,0.846,0.654C11.309,47.999,11.34,48,11.371,48c0.35,0,0.678-0.184,0.859-0.488l6.166-10.357 C20.168,37.703,22.05,38,24,38c1.85,0,3.633-0.278,5.325-0.773l6.121,10.284C35.628,47.816,35.955,48,36.305,48 c0.031,0,0.063-0.001,0.096-0.004c0.385-0.036,0.714-0.291,0.846-0.654l2.386-6.556l6.878,1.164 c0.387,0.065,0.767-0.098,0.988-0.416C47.72,41.215,47.737,40.798,47.543,40.463z M11.59,44.677l-1.95-5.358 c-0.166-0.454-0.63-0.726-1.107-0.644l-5.602,0.948l5.583-9.654c2.008,2.826,4.758,5.086,7.976,6.477L11.59,44.677z M7,19 C7,9.626,14.626,2,24,2s17,7.626,17,17s-7.626,17-17,17S7,28.374,7,19z M39.144,38.674c-0.476-0.081-0.941,0.19-1.107,0.644 l-1.95,5.358l-4.834-8.122c3.234-1.341,6.006-3.557,8.052-6.343l5.442,9.41L39.144,38.674z\"></path><path fill=\"#231F20\" d=\"M33,15h-5.382l-2.723-5.447c-0.339-0.678-1.45-0.678-1.789,0L20.382,15H15 c-0.425,0-0.803,0.268-0.944,0.669c-0.14,0.401-0.013,0.847,0.319,1.112l4.48,3.584l-1.817,6.36 c-0.114,0.398,0.03,0.825,0.36,1.074c0.331,0.249,0.781,0.267,1.132,0.049l5.47-3.42l5.47,3.42C29.632,27.95,29.816,28,30,28 c0.212,0,0.424-0.067,0.602-0.201c0.331-0.249,0.474-0.676,0.36-1.074l-1.817-6.36l4.48-3.584c0.332-0.265,0.459-0.711,0.319-1.112 C33.803,15.268,33.425,15,33,15z M27.375,19.219c-0.315,0.252-0.448,0.668-0.337,1.056l1.285,4.498l-3.793-2.372 c-0.162-0.101-0.346-0.152-0.53-0.152s-0.368,0.05-0.53,0.151l-3.793,2.373l1.285-4.498c0.111-0.388-0.022-0.804-0.337-1.056 L17.851,17H21c0.379,0,0.725-0.214,0.894-0.553L24,12.236l2.105,4.211C26.275,16.786,26.621,17,27,17h3.149L27.375,19.219z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/charticon.html","<div class=\"df-icon chart\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#010101\" d=\"M47,46h-1V17c0-0.552-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1v29h-4V31c0-0.552-0.447-1-1-1h-6 c-0.553,0-1,0.448-1,1v15h-4V27c0-0.552-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1v19h-4v-9c0-0.552-0.447-1-1-1H3c-0.553,0-1,0.448-1,1 v9H1c-0.553,0-1,0.448-1,1s0.447,1,1,1h2h6h6h6h6h6h6h6h2c0.553,0,1-0.448,1-1S47.553,46,47,46z M4,46v-8h4v8H4z M16,46V28h4v18H16 z M28,46V32h4v14H28z M40,46V18h4v28H40z\"></path><path fill=\"#010101\" d=\"M6,26c1.654,0,3-1.346,3-3c0-0.365-0.075-0.711-0.195-1.035l7.673-6.394C16.926,15.837,17.442,16,18,16 c0.958,0,1.803-0.46,2.353-1.161l6.653,2.216C27.036,18.683,28.365,20,30,20c1.654,0,3-1.346,3-3c0-0.543-0.156-1.046-0.41-1.486 l8.333-9.722C41.259,5.922,41.62,6,42,6c1.654,0,3-1.346,3-3s-1.346-3-3-3s-3,1.346-3,3c0,0.543,0.156,1.046,0.41,1.486 l-8.333,9.722C30.742,14.078,30.381,14,30,14c-0.958,0-1.802,0.459-2.352,1.16l-6.654-2.217C20.963,11.316,19.635,10,18,10 c-1.654,0-3,1.346-3,3c0,0.365,0.075,0.712,0.195,1.036L7.523,20.43C7.075,20.163,6.558,20,6,20c-1.654,0-3,1.346-3,3 S4.346,26,6,26z M42,2c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S41.448,2,42,2z M30,16c0.552,0,1,0.449,1,1s-0.448,1-1,1 s-1-0.449-1-1c0-0.052,0.022-0.097,0.03-0.147c0.027-0.05,0.061-0.096,0.079-0.152c0.018-0.055,0.012-0.109,0.02-0.165 C29.298,16.222,29.618,16,30,16z M18,12c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S17.448,12,18,12z M6,22 c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S5.448,22,6,22z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/document.html","<div class=\"df-icon document\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#231F20\" d=\"M41.923,12.616c-0.051-0.122-0.124-0.232-0.216-0.324L29.708,0.294c-0.092-0.092-0.202-0.166-0.324-0.217 C29.264,0.027,29.134,0,29,0H7C6.447,0,6,0.448,6,1v46c0,0.552,0.447,1,1,1h34c0.553,0,1-0.448,1-1V13 C42,12.867,41.973,12.737,41.923,12.616z M30,3.414L38.586,12H30V3.414z M8,46V2h20v11c0,0.552,0.447,1,1,1h11v32H8z\"></path><path fill=\"#231F20\" d=\"M15,16h9c0.553,0,1-0.448,1-1s-0.447-1-1-1h-9c-0.553,0-1,0.448-1,1S14.447,16,15,16z\"></path><path fill=\"#231F20\" d=\"M33,20H15c-0.553,0-1,0.448-1,1s0.447,1,1,1h18c0.553,0,1-0.448,1-1S33.553,20,33,20z\"></path><path fill=\"#231F20\" d=\"M33,26H15c-0.553,0-1,0.448-1,1s0.447,1,1,1h18c0.553,0,1-0.448,1-1S33.553,26,33,26z\"></path><path fill=\"#231F20\" d=\"M33,32H15c-0.553,0-1,0.448-1,1s0.447,1,1,1h18c0.553,0,1-0.448,1-1S33.553,32,33,32z\"></path><path fill=\"#231F20\" d=\"M33,38H15c-0.553,0-1,0.448-1,1s0.447,1,1,1h18c0.553,0,1-0.448,1-1S33.553,38,33,38z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/files.html","<div class=\"df-icon users\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#231F20\" d=\"M37,26.001c-6.065,0-11,4.935-11,11s4.935,11,11,11s11-4.935,11-11S43.065,26.001,37,26.001z M37,46.001 c-4.963,0-9-4.038-9-9c0-4.962,4.037-9,9-9s9,4.038,9,9C46,41.963,41.963,46.001,37,46.001z\"></path><path fill=\"#231F20\" d=\"M42,36.001h-4v-4c0-0.552-0.447-1-1-1s-1,0.448-1,1v4h-4c-0.553,0-1,0.448-1,1s0.447,1,1,1h4v4 c0,0.552,0.447,1,1,1s1-0.448,1-1v-4h4c0.553,0,1-0.448,1-1S42.553,36.001,42,36.001z\"></path><path fill=\"#231F20\" d=\"M27.62,27.513l0.627-1.899l-0.133-0.044c-1.333-0.44-2.706-0.893-4.112-1.408v-3.727 c0.972-0.651,2.763-2.318,2.978-5.863c0.734-0.471,1.195-1.488,1.195-2.787c0-1.139-0.356-2.062-0.938-2.589 c0.487-1.232,1.282-3.376,0.734-5.581c-0.665-2.669-4.44-3.616-7.471-3.616c-0.001,0-0.002,0-0.002,0 c-2.685,0-5.952,0.744-7.125,2.768c-1.038-0.058-1.833,0.22-2.396,0.832c-1.336,1.453-0.594,4.155-0.153,5.68 c-0.233,0.19-0.434,0.439-0.591,0.74c-0.263,0.503-0.407,1.156-0.407,1.838c0,1.269,0.462,2.263,1.196,2.722 c0.217,3.54,2.007,5.206,2.979,5.856v3.728c-1.238,0.453-2.521,0.876-3.768,1.288c-4.702,1.552-8.415,2.778-9.182,5.092 C0.064,33.515,0.002,38.769,0,38.991c-0.003,0.267,0.102,0.524,0.289,0.714C0.477,39.894,0.733,40.001,1,40.001h21v-2H2.029 c0.065-1.637,0.273-4.88,0.92-6.828c0.45-1.361,4.413-2.668,7.91-3.822c1.485-0.491,3.022-0.998,4.496-1.558 C15.743,25.645,16,25.273,16,24.858v-5c0-0.405-0.244-0.77-0.618-0.924C15.357,18.924,13,17.904,13,13.858 c0-0.553-0.364-0.974-0.916-0.974c-0.07-0.055-0.259-0.402-0.259-1.026c0-0.624,0.19-0.971,0.175-1c0.553,0,1-0.448,1-1 c0-0.25-0.075-0.509-0.225-1.025c-0.23-0.796-0.932-3.219-0.326-3.878c0.191-0.208,0.684-0.25,1.354-0.116 c0.521,0.103,1.038-0.22,1.168-0.739c0.297-1.197,2.673-2.099,5.527-2.099c0.001,0,0.001,0,0.002,0 c2.854,0,5.231,0.903,5.529,2.099c0.417,1.675-0.318,3.521-0.713,4.513C25.112,9.125,25,9.407,25,9.715 c0,0.528,0.409,0.96,0.928,0.997c0.085,0.112,0.246,0.473,0.246,1.074s-0.161,0.963-0.246,1.074C25.409,12.898,25,13.33,25,13.858 c0,3.973-2.296,5.037-2.382,5.076C22.244,19.088,22,19.453,22,19.858v5c0,0.416,0.258,0.789,0.649,0.935 c1.672,0.631,3.281,1.162,4.837,1.676L27.62,27.513z\"></path></g><g id=\"nyt_x5F_exporter_x5F_info\" display=\"none\"></g></svg></div>");
$templateCache.put("app/components/IconDirectives/lock.html","<div class=\"df-icon users\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#231F20\" d=\"M24,28c-1.105,0-2,0.895-2,2c0,0.738,0.405,1.376,1,1.723V37c0,0.552,0.447,1,1,1s1-0.448,1-1v-5.277 c0.595-0.346,1-0.984,1-1.723C26,28.895,25.105,28,24,28z\"></path><path fill=\"#231F20\" d=\"M36,18v-6c0-6.617-5.383-12-12-12S12,5.383,12,12v6H6v30h36V18H36z M14,12c0-5.514,4.486-10,10-10 s10,4.486,10,10v6H14V12z M40,46H8V20h4h24h4V46z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/offers.html","<div class=\"df-icon users\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#231F20\" d=\"M37,26.001c-6.065,0-11,4.935-11,11s4.935,11,11,11s11-4.935,11-11S43.065,26.001,37,26.001z M37,46.001 c-4.963,0-9-4.038-9-9c0-4.962,4.037-9,9-9s9,4.038,9,9C46,41.963,41.963,46.001,37,46.001z\"></path><path fill=\"#231F20\" d=\"M42,36.001h-4v-4c0-0.552-0.447-1-1-1s-1,0.448-1,1v4h-4c-0.553,0-1,0.448-1,1s0.447,1,1,1h4v4 c0,0.552,0.447,1,1,1s1-0.448,1-1v-4h4c0.553,0,1-0.448,1-1S42.553,36.001,42,36.001z\"></path><path fill=\"#231F20\" d=\"M27.62,27.513l0.627-1.899l-0.133-0.044c-1.333-0.44-2.706-0.893-4.112-1.408v-3.727 c0.972-0.651,2.763-2.318,2.978-5.863c0.734-0.471,1.195-1.488,1.195-2.787c0-1.139-0.356-2.062-0.938-2.589 c0.487-1.232,1.282-3.376,0.734-5.581c-0.665-2.669-4.44-3.616-7.471-3.616c-0.001,0-0.002,0-0.002,0 c-2.685,0-5.952,0.744-7.125,2.768c-1.038-0.058-1.833,0.22-2.396,0.832c-1.336,1.453-0.594,4.155-0.153,5.68 c-0.233,0.19-0.434,0.439-0.591,0.74c-0.263,0.503-0.407,1.156-0.407,1.838c0,1.269,0.462,2.263,1.196,2.722 c0.217,3.54,2.007,5.206,2.979,5.856v3.728c-1.238,0.453-2.521,0.876-3.768,1.288c-4.702,1.552-8.415,2.778-9.182,5.092 C0.064,33.515,0.002,38.769,0,38.991c-0.003,0.267,0.102,0.524,0.289,0.714C0.477,39.894,0.733,40.001,1,40.001h21v-2H2.029 c0.065-1.637,0.273-4.88,0.92-6.828c0.45-1.361,4.413-2.668,7.91-3.822c1.485-0.491,3.022-0.998,4.496-1.558 C15.743,25.645,16,25.273,16,24.858v-5c0-0.405-0.244-0.77-0.618-0.924C15.357,18.924,13,17.904,13,13.858 c0-0.553-0.364-0.974-0.916-0.974c-0.07-0.055-0.259-0.402-0.259-1.026c0-0.624,0.19-0.971,0.175-1c0.553,0,1-0.448,1-1 c0-0.25-0.075-0.509-0.225-1.025c-0.23-0.796-0.932-3.219-0.326-3.878c0.191-0.208,0.684-0.25,1.354-0.116 c0.521,0.103,1.038-0.22,1.168-0.739c0.297-1.197,2.673-2.099,5.527-2.099c0.001,0,0.001,0,0.002,0 c2.854,0,5.231,0.903,5.529,2.099c0.417,1.675-0.318,3.521-0.713,4.513C25.112,9.125,25,9.407,25,9.715 c0,0.528,0.409,0.96,0.928,0.997c0.085,0.112,0.246,0.473,0.246,1.074s-0.161,0.963-0.246,1.074C25.409,12.898,25,13.33,25,13.858 c0,3.973-2.296,5.037-2.382,5.076C22.244,19.088,22,19.453,22,19.858v5c0,0.416,0.258,0.789,0.649,0.935 c1.672,0.631,3.281,1.162,4.837,1.676L27.62,27.513z\"></path></g><g id=\"nyt_x5F_exporter_x5F_info\" display=\"none\"></g></svg></div>");
$templateCache.put("app/components/IconDirectives/person-add.html","<div class=\"df-icon chart\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#010101\" d=\"M47,46h-1V17c0-0.552-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1v29h-4V31c0-0.552-0.447-1-1-1h-6 c-0.553,0-1,0.448-1,1v15h-4V27c0-0.552-0.447-1-1-1h-6c-0.553,0-1,0.448-1,1v19h-4v-9c0-0.552-0.447-1-1-1H3c-0.553,0-1,0.448-1,1 v9H1c-0.553,0-1,0.448-1,1s0.447,1,1,1h2h6h6h6h6h6h6h6h2c0.553,0,1-0.448,1-1S47.553,46,47,46z M4,46v-8h4v8H4z M16,46V28h4v18H16 z M28,46V32h4v14H28z M40,46V18h4v28H40z\"></path><path fill=\"#010101\" d=\"M6,26c1.654,0,3-1.346,3-3c0-0.365-0.075-0.711-0.195-1.035l7.673-6.394C16.926,15.837,17.442,16,18,16 c0.958,0,1.803-0.46,2.353-1.161l6.653,2.216C27.036,18.683,28.365,20,30,20c1.654,0,3-1.346,3-3c0-0.543-0.156-1.046-0.41-1.486 l8.333-9.722C41.259,5.922,41.62,6,42,6c1.654,0,3-1.346,3-3s-1.346-3-3-3s-3,1.346-3,3c0,0.543,0.156,1.046,0.41,1.486 l-8.333,9.722C30.742,14.078,30.381,14,30,14c-0.958,0-1.802,0.459-2.352,1.16l-6.654-2.217C20.963,11.316,19.635,10,18,10 c-1.654,0-3,1.346-3,3c0,0.365,0.075,0.712,0.195,1.036L7.523,20.43C7.075,20.163,6.558,20,6,20c-1.654,0-3,1.346-3,3 S4.346,26,6,26z M42,2c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S41.448,2,42,2z M30,16c0.552,0,1,0.449,1,1s-0.448,1-1,1 s-1-0.449-1-1c0-0.052,0.022-0.097,0.03-0.147c0.027-0.05,0.061-0.096,0.079-0.152c0.018-0.055,0.012-0.109,0.02-0.165 C29.298,16.222,29.618,16,30,16z M18,12c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S17.448,12,18,12z M6,22 c0.552,0,1,0.449,1,1s-0.448,1-1,1s-1-0.449-1-1S5.448,22,6,22z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/person-edit.html","<div class=\"df-icon chart\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path fill=\"#231F20\" d=\"M47.707,31.293l-5-5c-0.391-0.391-1.023-0.391-1.414,0l-13,13c-0.084,0.084-0.145,0.185-0.194,0.292 c-0.012,0.026-0.024,0.051-0.033,0.078c-0.008,0.021-0.02,0.04-0.026,0.062l-2,7c-0.1,0.35-0.003,0.725,0.254,0.982 C26.483,47.898,26.738,48,27,48c0.092,0,0.184-0.013,0.275-0.039l7-2c0.022-0.006,0.041-0.019,0.063-0.027 c0.026-0.01,0.051-0.021,0.077-0.033c0.107-0.049,0.209-0.11,0.293-0.194l13-13C48.098,32.316,48.098,31.684,47.707,31.293z M28.456,45.544l1.039-3.636l2.597,2.597L28.456,45.544z M34,43.586L30.414,40L38,32.414L41.586,36L34,43.586z M43,34.586 L39.414,31L42,28.414L45.586,32L43,34.586z\"></path><path fill=\"#231F20\" d=\"M30.679,31.983l0.642-1.893L26,28.283v-4.598c2.866-2.349,4.75-6.259,4.75-10.685c0-7.168-4.935-13-11-13 s-11,5.832-11,13c0,4.676,2.107,8.771,5.25,11.061v4.234l-9.356,3.341C1.866,32.629,0,35.278,0,38.228V44h22v-2H2v-3.772 c0-2.107,1.333-3.999,3.317-4.708L16,29.705v-4.5C17.172,25.71,18.432,26,19.75,26c1.506,0,2.942-0.361,4.25-1.011v4.728 L30.679,31.983z M19.75,2c4.406,0,8.077,3.895,8.845,9.014c-0.012,0.002-0.022,0.002-0.033,0.004 c-2.909,0.561-4.705-0.387-6.412-3.374l-0.908-1.589l-0.847,1.623C19.471,9.448,16.366,11,13.75,11 c-1.017,0-1.891-0.169-2.752-0.521C11.934,5.627,15.499,2,19.75,2z M19.75,24c-4.962,0-9-4.935-9-11c0-0.162,0.014-0.32,0.02-0.481 C11.708,12.835,12.679,13,13.75,13c2.748,0,5.761-1.307,7.469-3.1c1.594,2.219,3.474,3.271,5.863,3.271 c0.528,0,1.086-0.059,1.668-0.162C28.746,19.07,24.71,24,19.75,24z\"></path></g><g id=\"nyt_x5F_exporter_x5F_info\" display=\"none\"></g></svg></div>");
$templateCache.put("app/components/IconDirectives/search.html","<div class=\"df-icon users\"><svg version=\"1.0\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><g><path d=\"M37.949,29.684C37.813,29.275,37.431,29,37,29h-9.236l-2.799-10.263C24.846,18.302,24.451,18,24,18 c-0.451,0-0.846,0.302-0.965,0.737L20.236,29H11c-0.431,0-0.812,0.275-0.949,0.684c-0.136,0.408,0.004,0.858,0.349,1.116 l7.387,5.54l-3.716,9.289c-0.168,0.42-0.033,0.899,0.328,1.17c0.36,0.271,0.859,0.268,1.215-0.01L24,40.267l8.386,6.522 C32.566,46.929,32.783,47,33,47c0.211,0,0.423-0.067,0.601-0.201c0.361-0.271,0.495-0.751,0.328-1.17l-3.716-9.289L37.6,30.8 C37.944,30.542,38.085,30.092,37.949,29.684z M28.4,35.2c-0.362,0.271-0.496,0.752-0.329,1.171l2.629,6.574l-6.087-4.734 C24.434,38.07,24.217,38,24,38c-0.217,0-0.434,0.07-0.614,0.21l-6.087,4.734l2.629-6.574c0.167-0.419,0.033-0.9-0.329-1.171L14,31 h7c0.451,0,0.846-0.302,0.965-0.737L24,22.8l2.035,7.463C26.154,30.698,26.549,31,27,31h7L28.4,35.2z\"></path><path d=\"M17.187,23.982c0.543-0.104,0.898-0.627,0.795-1.169L14.209,3H20v12c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1V3h4v12 c0,0.552,0.448,1,1,1c0.552,0,1-0.448,1-1V3h5.791l-3.774,19.813c-0.103,0.543,0.253,1.066,0.795,1.169 C30.876,23.994,30.939,24,31.001,24c0.471,0,0.89-0.333,0.981-0.813l4-21c0.056-0.293-0.022-0.595-0.212-0.825 C35.581,1.133,35.298,1,35,1H13c-0.298,0-0.581,0.133-0.771,0.362c-0.19,0.229-0.268,0.532-0.212,0.825l4,21 C16.121,23.729,16.647,24.086,17.187,23.982z\"></path></g></svg></div>");
$templateCache.put("app/components/IconDirectives/users.html","<div class=\"df-icon users\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewbox=\"0 0 48 48\" enable-background=\"new 0 0 48 48\" xml:space=\"preserve\"><path fill=\"#231F20\" d=\"M40.354,36.635L31,33.295v-4.61c2.866-2.349,4.75-6.259,4.75-10.685c0-7.168-4.935-13-11-13s-11,5.832-11,13 c0,4.676,2.107,8.771,5.25,11.061v4.234l-9.355,3.341C6.867,37.629,5,40.278,5,43.228V48h40v-4.772 C45,40.278,43.133,37.629,40.354,36.635z M24.75,7c4.406,0,8.077,3.895,8.845,9.014c-0.012,0.002-0.022,0.002-0.034,0.004 c-2.908,0.562-4.704-0.387-6.412-3.374l-0.908-1.589l-0.847,1.623C24.471,14.448,21.366,16,18.75,16 c-1.018,0-1.892-0.169-2.752-0.521C16.934,10.627,20.499,7,24.75,7z M15.75,18c0-0.162,0.014-0.32,0.02-0.48 c0.937,0.315,1.908,0.48,2.98,0.48c2.748,0,5.761-1.307,7.469-3.1c1.594,2.219,3.474,3.271,5.863,3.271 c0.528,0,1.087-0.059,1.668-0.162C33.746,24.07,29.71,29,24.75,29C19.788,29,15.75,24.065,15.75,18z M43,46H7v-2.772 c0-2.107,1.333-3.999,3.318-4.708L21,34.705v-4.5C22.172,30.71,23.432,31,24.75,31c1.506,0,2.942-0.361,4.25-1.011v4.716 l10.681,3.815C41.666,39.229,43,41.121,43,43.228V46z\"></path><g id=\"nyt_x5F_exporter_x5F_info\" display=\"none\"></g></svg></div>");
$templateCache.put("app/components/IconLink/template.html","<section class=\"app-icon-link {{klass}}\"><a ng-href=\"{{href}}\"><div class=\"action-icon\"><div ng-transclude=\"\"></div></div><div class=\"action-text\">{{text}}</div></a></section>");
$templateCache.put("app/components/Input/template.html","");
$templateCache.put("app/components/Logo/template.html","<section class=\"app-logo {{klass}}\"><div class=\"text\">K</div></section>");
$templateCache.put("app/components/Media/template.html","<section class=\"app-media {{klass}}\"><div class=\"image-container\"><img ng-src=\"./assets/images/{{imaged}}\" alt=\"\" class=\"hero-img show-for-large\"> <img ng-src=\"./assets/images/{{imaget}}\" alt=\"\" class=\"hero-img show-for-medium-only\"> <img ng-src=\"./assets/images/{{imagem}}\" alt=\"\" class=\"hero-img show-for-small-only\"></div><div class=\"background-mask\"></div><div class=\"content-wrapper\"><div class=\"row\"><div class=\"column align-middle\"><div class=\"hero-text text-center\"><div class=\"intro-text\">{{\'ad\' || intro}}</div><h2 class=\"hero-title\">{{ttl}}</h2><h3 class=\"hero-sub-title\">{{subtitle}}</h3><a class=\"button invert\" href=\"#/\">Learn more</a></div></div></div></div></section>");
$templateCache.put("app/components/NavBar/template.html","<section class=\"\" style=\"position: fixed; top: 0; width:100%; z-index: 1000;\"><div class=\"app-nav-bar top-bar\"><div class=\"top-bar-title\" onclick=\"\"><span data-responsive-toggle=\"responsive-menu\" data-hide-for=\"medium\"><span class=\"menu-icon dark\" data-toggle=\"\"></span></span> <span class=\"app-title\">&nbsp;&nbsp;<app-logo></app-logo><span class=\"title-text\">&nbsp;&nbsp;KDOT</span> <span class=\"by-line\">BRANDING & PRODUCT DEVELOPMENT</span></span></div><div id=\"responsive-menu\"><div class=\"top-bar-right\"><ul class=\"vertical medium-horizontal dropdown menu\" data-dropdown-menu=\"\" ng-if=\"!currentUser\"><li><a href=\"#/home\">Home</a></li><li><a href=\"#/home\">Branding</a></li><li><a href=\"#/home\">Product Development</a></li><li><a href=\"#/home\">Inventors</a></li><li><a href=\"#/home\">Manufacturing</a></li></ul><ul class=\"vertical medium-horizontal dropdown menu\" data-dropdown-menu=\"\" ng-if=\"currentUser\"><li><a href=\"#/home\">Home</a></li><li><a href=\"#/myaccount\">My Account</a></li><li ng-if=\"currentUser.admin\"><a href=\"#/admin\">Admin</a></li><li><a href=\"\" ng-click=\"vm.logout()\">Logout</a></li></ul></div></div></div></section>");
$templateCache.put("app/components/NavBar2/template.html","<section class=\"app-nav-bar2 {{klass}}\"><div class=\"bar-wrapper row align-middle {{fadeDown}}\"><div class=\"column small-12 large-4\"><div class=\"title-block\"><div class=\"site-logo\"><app-logo klass=\"\'medium ghost\'\"></app-logo></div><div class=\"site-title\">KDOT</div></div></div><div class=\"column small-12 large-8\" id=\"mobilemenu\" data-toggler=\".show-it\"><div class=\"row large-unstack\" data-magellan=\"\"><div class=\"column {{anim}}\"><app-iconlink href=\"\'#home\'\" text=\"\'Home\'\" klass=\"\'active\'\"><icon-home3></icon-home3></app-iconlink></div><div class=\"column {{anim}} _1\"><app-iconlink href=\"\'#branding\'\" text=\"\'Branding\'\" klass=\"\'\'\"><icon-home3></icon-home3></app-iconlink></div><div class=\"column {{anim}} _2\"><app-iconlink href=\"\'#buildit\'\" text=\"\'Products\'\" klass=\"\'\'\"><icon-home3></icon-home3></app-iconlink></div><div class=\"column {{anim}} _3\"><app-iconlink href=\"\'mailto:kay@kdot.biz\'\" text=\"\'Contact us\'\" klass=\"\'\'\"><icon-home3></icon-home3></app-iconlink></div></div></div></div></section>");
$templateCache.put("app/components/Page/template.html","<section class=\"app-page {{klass}}\"><app-section klass=\"\'bg-gray-light-3\'\" ng-if=\"ttl\"><app-row><h3 class=\"page-title\" ng-show=\"ttl\">{{ttl}} <span class=\"subheader\">{{subtitle}}</span></h3></app-row></app-section><div ng-transclude=\"\"></div></section>");
$templateCache.put("app/components/Photo/template.html","<div class=\"app-photo {{klass}}\"><div class=\"image-container\"><img ng-src=\"{{image}}\" alt=\"\"></div><p class=\"title\" ng-show=\"ttl\">{{ttl}}</p><p class=\"subtitle\" ng-show=\"subtitle\">{{subtitle}}</p></div>");
$templateCache.put("app/components/Row/template.html","<div class=\"row app-row {{klass}}\"><div class=\"small-12 columns\"><div ng-transclude=\"\"></div></div></div>");
$templateCache.put("app/components/RichTextarea/template.html","<section class=\"app-richtextarea {{klass}}\"><div class=\"row\"><div class=\"small-12 columns\"><div class=\"label-wrapper\"><label for=\"{{id}}\"><span class=\"label-text\">{{label}}</span> <span class=\"hint\">{{hint}}</span></label></div><div class=\"input-wrapper\"><ng-quill-editor ng-model=\"ngModel\" toolbar=\"{{toolbar}}\" link-tooltip=\"linkTooltip\" image-tooltip=\"imageTooltip\" toolbar-entries=\"{{toolbarEntries}}\" editor-required=\"editorRequired\" required=\"inputRequired\" error-class=\"inputError\"></ng-quill-editor></div></div></div></section>");
$templateCache.put("app/components/Section/template.html","<section id=\"{{zid}}\" class=\"app-section {{klass}}\" ng-class=\"{\'text-center featured\' : featured, \'has-image\': image || unsplash, \'has-light-text\' : lighttext }\" data-magellan-target=\"{{zid}}\"><div class=\"baby-header text-center\" ng-if=\"intro\">{{intro}}</div><div class=\"row\"><div class=\"small-12 columns\"><div class=\"text-wrapper\"><div class=\"section-title\" ng-if=\"ttl\">{{ttl}}</div><div class=\"section-sub-title\" ng-if=\"subtitle\">{{subtitle}}</div><div class=\"desc\" ng-if=\"desc\">{{desc}}</div><a href=\"\" class=\"button {{ctaclass}}\" ng-show=\"cta\">{{cta}}</a></div></div><div class=\"small-12 columns\" ng-if=\"image || unsplash\"><div class=\"image-container\"><img ng-src=\"./assets/images/{{image}}\" alt=\"\" class=\"section-img\"> <img ng-src=\"{{unsplash}}\" alt=\"\" class=\"section-img\"></div></div><div class=\"small-12 columns\"><div ng-transclude=\"\"></div></div></div></section>");
$templateCache.put("app/components/Submit/template.html","<section class=\"app-submit\"><div class=\"row\"><div class=\"small-12 columns\"><div class=\"label-wrapper\"><div>&nbsp;</div></div><div class=\"input-wrapper\"><div class=\"submit-wrapper\"><div class=\"loader-wrapper\"><app-loader></app-loader></div><input class=\"button {{klass}}\" type=\"submit\" value=\"{{txt || \'Submit\'}}\"></div></div></div></div></section>");
$templateCache.put("app/components/Textarea/template.html","");}]);